
import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import "jspdf/dist/polyfills.es.js"; 
import Select from "react-select";
// add these with your other imports
import JsBarcode from 'jsbarcode';
import ReactDOM from 'react-dom';
import NewBroker from '../models/NewBroker';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ProcedureBillModal from '../models/ProcedureBillModal';
// 👇 the SAME components behind /registrations and /emergency_reg (set real paths/names)
import LabRegistrations from './Registrations';   // file is Registrations.js, aliased to LabRegistrations
import EmergencyReg from './emergency_reg';     // emergency page (route /emergency_reg)

function OpdRegistrations() {
  const [defaultRegFees, setDefaultRegFees] = useState('0');
  const navigate = useNavigate();
    const [ldata, setLdata] = useState(null);
    const [uhidSuggestions, setUhidSuggestions] = useState([]);
    const [isSaved, setIsSaved] = useState(false);
    
      const [specSearch, setSpecSearch] = useState("");
  const [docSearch, setDocSearch] = useState("");
  const [showSpecOptions, setShowSpecOptions] = useState(false);
  const [showDocOptions, setShowDocOptions] = useState(false);
const [filteredDoctors, setFilteredDoctors] = useState([]);
const [printType, setPrintType] = useState('header');
const [showPopup, setShowPopup] = useState(false);
const [returnToActionModal, setReturnToActionModal] = useState(false);
const [customOpdFormat, setCustomOpdFormat] = useState(null);
const [formatLoading, setFormatLoading] = useState(false);
 
const [showBrokerModal, setShowBrokerModal] = useState(false);

const [originalRecord, setOriginalRecord] = useState(null);
const [showActionModal, setShowActionModal] = useState(false);
const [hasCityCol, setHasCityCol]   = useState(false);
const [hasStateCol, setHasStateCol] = useState(false);



// ── Broker states ──
const [brokers, setBrokers] = useState([]);
const [selectedBroker, setSelectedBroker] = useState(null);
const [brokerCommission, setBrokerCommission] = useState(0);

// ── OPD Payment modal states ──
const [showPaymentModal, setShowPaymentModal] = useState(false);
const [paymentMode, setPaymentMode] = useState('Cash');
const [paymentAmount, setPaymentAmount] = useState('');
const [paymentReceivedBy, setPaymentReceivedBy] = useState('');
const [paymentHistory, setPaymentHistory] = useState([]);

const [showProcedureModal, setShowProcedureModal] = useState(false);
const [procedurePatientData, setProcedurePatientData] = useState(null);
const [showLabModal, setShowLabModal] = useState(false);
const [showEmergencyModal, setShowEmergencyModal] = useState(false);
const [movingToIpd, setMovingToIpd] = useState(false);

const [Name, setName] = useState('');
 // 'header' or 'noheader'
const [docType, setDocType] = useState(''); // 'receipt' or 'prescription'
// Add these at the top of your OpdRegistrations component
const [headerLogo, setHeaderLogo] = useState('');

const [watermarkLogo, setWatermarkLogo] = useState('');
   const [footerImage, setFooterImage] = useState('');
   const [lastSavedPaid, setLastSavedPaid] = useState(''); // tracks paid amount at last successful save
   const [lastSavedDue, setLastSavedDue] = useState('');   // optional — tracks due at last save
   const [slotUnavailableReason, setSlotUnavailableReason] = useState('');
   const [opdSearchMode, setOpdSearchMode] = useState('phone');
   const [opdPhoneSearch, setOpdPhoneSearch] = useState('');
   const [opdSearchLoading, setOpdSearchLoading] = useState(false);
   const [opdPatientResults, setOpdPatientResults] = useState([]);
   const [showOpdPatientModal, setShowOpdPatientModal] = useState(false);
   const [opdSearchInput, setOpdSearchInput] = useState('');


   const [doctorSlots, setDoctorSlots] = useState([]);
const [selectedSlot, setSelectedSlot] = useState(null);
// ✅ NEW: appointment date (can be different from registration date)
const [slotDate, setSlotDate] = useState(() => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
});
const [slotsLoading, setSlotsLoading] = useState(false);

   const [ageYears, setAgeYears] = useState('');
   const [ageMonths, setAgeMonths] = useState('');
   const [ageDays, setAgeDays] = useState('');
   
   
// Convert many backend date formats into a value usable by <input type="date">
const toDateInputValue = (val) => {
  if (!val) return '';
  // if already in YYYY-MM-DD form return as-is
  if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
  // try to parse with Date
  const t = new Date(val);
  if (isNaN(t.getTime())) return ''; // fallback empty
  return t.toISOString().split('T')[0];
};

const handlePrintSelect = (type) => {
  setPrintType(type);
  setShowPopup(false);
 
  if (docType === 'receipt') {
    // ✅ RECEIPT — ALWAYS default, no custom format ever
    handlePrint(type);
  } else if (docType === 'prescription') {
    // ✅ PRESCRIPTION — check custom format
    if (customOpdFormat && customOpdFormat.format_image) {
      generateCustomPrescriptionPdf(type);
    } else {
      handlePrintPrescription(type);
    }
  }
};
   // near other refs at top of component
const barcodeCanvasRef = useRef(null);

// generate barcode PNG dataURL using an offscreen canvas (same approach as lab)
const generateBarcodeDataUrl = (value, options = {}) => {
  const canvas = barcodeCanvasRef.current || document.createElement('canvas');
  const v = (value && String(value).trim()) ? String(value).trim() : 'NA';
  try {
    JsBarcode(canvas, v, {
      format: options.format || 'CODE128',
      width: options.width || 2,
      height: options.height || 60,
      displayValue: options.displayValue === undefined ? false : options.displayValue,
      margin: options.margin || 5,
      textMargin: 0
    });
    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('Barcode generation failed', err);
    return null;
  }
};
// Print via hidden iframe (thermal-friendly)
const escapeHtml = (unsafe) => {
  if (!unsafe) return '';
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const printThermalBarcodeIframe = async (patientName, age, uhid) => {
  // 1) Generate barcode data URL
  const barcodeData = generateBarcodeDataUrl(uhid, { width: 2, height: 70, displayValue: false });

  // 2) build printable HTML
  const css = `
    <style>
      @media print {
        @page { size: 80mm auto; margin: 4mm; }
      }
      body {
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 6px;
        color: #000;
        width: 280px; /* ~80mm */
      }
      .ticket { text-align:center; padding:2px 4px; }
      .title { font-size:14px; font-weight:700; margin-bottom:6px; }
      .meta { font-size:12px; margin:2px 0; }
      .uhid { font-size:12px; font-weight:700; margin-top:6px; }
      .barcode { margin-top:8px; }
      img.barimg { max-width:100%; height:auto; }
      .small { font-size:10px; color:#333; margin-top:6px; }
    </style>
  `;

  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Print Barcode</title>${css}</head>
    <body>
      <div class="ticket">
        <div class="meta">Name: ${escapeHtml(patientName || 'N/A')}</div>
        <div class="meta">Age: ${escapeHtml(age || 'N/A')}</div>
        <div class="uhid">UHID: ${escapeHtml(uhid || 'N/A')}</div>
        <div class="barcode">${ barcodeData ? `<img class="barimg" src="${barcodeData}" alt="${escapeHtml(uhid)}"/>` : '<div style="height:60px">Barcode error</div>' }</div>
        <div class="small">Generated: ${new Date().toLocaleString()}</div>
      </div>
    </body></html>`;

  // 3) reuse or create hidden iframe
  const existing = document.getElementById('thermal-print-iframe');
  let iframe;
  if (existing) {
    iframe = existing;
    iframe.srcdoc = 'about:blank';
  } else {
    iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.id = 'thermal-print-iframe';
    document.body.appendChild(iframe);
  }

  return new Promise((resolve, reject) => {
    const onLoad = () => {
      try {
        const iwin = iframe.contentWindow;
        const imgs = iframe.contentDocument.getElementsByTagName('img');
        if (imgs.length === 0) {
          iwin.focus();
          iwin.print();
          resolve(true);
        } else {
          let loadedCount = 0;
          const checkDone = () => {
            loadedCount++;
            if (loadedCount >= imgs.length) {
              try {
                iwin.focus();
                iwin.print();
                resolve(true);
              } catch (err) {
                reject(err);
              }
            }
          };
          for (let img of imgs) {
            if (img.complete) checkDone();
            else {
              img.addEventListener('load', checkDone);
              img.addEventListener('error', checkDone); // still proceed
            }
          }
        }
      } catch (err) {
        reject(err);
      }
    };

    if ('srcdoc' in iframe) {
      iframe.onload = onLoad;
      iframe.srcdoc = html;
    } else {
      iframe.onload = onLoad;
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    }

    // safety timeout (resolve false if nothing prints)
    setTimeout(() => resolve(false), 8000);
  }).catch(err => {
    console.error('Print iframe error', err);
    return false;
  });
};

const fetchOpdFormat = async (specialityId) => {
  setFormatLoading(true);
  try {
    const fd = new FormData();
    fd.append('speciality_id', specialityId || '');   // empty is fine → backend returns "All"
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.getOpdFormatBySpecUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (res.data.status && res.data.format) {
      setCustomOpdFormat(res.data.format);
    } else {
      setCustomOpdFormat(null);
    }
  } catch (err) {
    console.error('fetchOpdFormat error:', err);
    setCustomOpdFormat(null);
  } finally {
    setFormatLoading(false);
  }
};

   // update numeric years in formData when years change (keeps backwards compatibility)
   const syncAgeToForm = (y, m, d) => {
     // y may be '' or a number string — ensure we store numeric years (or 0)
     const yearsNum = y === '' ? '' : String(Number(y) || 0);
     setFormData(prev => ({
       ...prev,
       opd_guardien_age: yearsNum
     }));
   };

   const fetchOpdColumns = async () => {
    try {
      const fd = new FormData();
      fd.append('page_no', '0');
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getOpdListUrl, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
  
      // Only show City/State if backend explicitly confirms the columns
      const cols = res.data?.columns;
      if (cols) {
        setHasCityCol(cols.opd_city === true);
        setHasStateCol(cols.opd_state === true);
      } else {
        // old backend without the columns block → address only
        setHasCityCol(false);
        setHasStateCol(false);
      }
    } catch (err) {
      // call failed → address only
      setHasCityCol(false);
      setHasStateCol(false);
      console.warn('column check failed', err);
    }
  };

   const formatDateTimeForReceipt = (isoOrDate) => {
    let d;
    if (!isoOrDate) {
        d = new Date();
    } else if (typeof isoOrDate === 'string') {
        // Handle "YYYY-MM-DD HH:MM:SS" format from database
        if (isoOrDate.includes(' ')) {
            const [datePart, timePart] = isoOrDate.split(' ');
            d = new Date(`${datePart}T${timePart}`);
        } else {
            d = new Date(isoOrDate);
        }
    } else {
        d = new Date(isoOrDate);
    }
    
    // If invalid date, use current time
    if (isNaN(d.getTime())) {
        d = new Date();
    }

    // ✅ ADD THIS RETURN STATEMENT
    // Day number with leading zero
    const dd = String(d.getDate()).padStart(2, '0');
    // Month short name
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();
  
    // 12-hour time
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if (hours === 0) hours = 12;
    const hh = String(hours).padStart(2, '0');
  
    return `${dd}- ${mon}-${yyyy} ${hh}:${minutes} ${ampm}`;
};
  const getSpecialityName = (spec) => {
    if (spec === null || spec === undefined || spec === '') return '';
    if (typeof spec === 'string' && !/^\d+$/.test(spec)) return spec;
    const idStr = String(spec);
    const cats = Array.isArray(formData.cats) ? formData.cats : [];
    const found = cats.find(c =>
      String(c.cat_id ?? c.id ?? c.value ?? c.key ?? '').toLowerCase() === idStr.toLowerCase()
    );
    if (found) {
      return (found.cat_name ?? found.name ?? found.title ?? found.label ?? String(spec)).toString();
    }
    return String(spec);
  };
  const renderDesignationAndSpeciality = (doc = {}) => {
    const designation = (doc?.doc_designation ?? '').toString().trim();
    const specialityRaw = doc?.doc_specality ?? '';
    const speciality = getSpecialityName(specialityRaw).toString().trim();
    if (designation) return speciality ? `${designation} (${speciality})` : designation;
    return speciality;
  };



  // Fetch OPD payment history
const fetchOpdPaymentHistory = async (opdId) => {
  if (!opdId) return;
  try {
    const fd = new FormData();
    fd.append('opd_id', opdId);
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.opdPaymentUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (response.data.status) setPaymentHistory(response.data.records || []);
  } catch (error) {
    console.error("Error fetching OPD payment history:", error);
  }
};

// Add a payment (uses the same opd_payment endpoint as the OPD list)
const handleAddPayment = async () => {
  const cleaned = String(paymentAmount).replace(/[,₹Rs\s]/g, '').trim();
  const amount = parseFloat(cleaned);
  const due = parseFloat(String(formData.opd_due).replace(/[,]/g, '')) || 0;

  if (!paymentAmount || amount <= 0 || isNaN(amount)) {
    toast.error("Please enter a valid payment amount");
    return;
  }
  if (amount > due) {
    toast.error(`Payment (₹${amount.toFixed(2)}) cannot exceed due (₹${due.toFixed(2)})`);
    return;
  }

  try {
    const fd = new FormData();
    fd.append('opd_id', formData.opd_id);
    fd.append('payment_amount', amount.toString());
    fd.append('payment_mode', paymentMode);
    fd.append('payment_date', new Date().toISOString().split('T')[0]);
    fd.append('payment_time', new Date().toTimeString().split(' ')[0]);
    fd.append('user_id', ldata?.user_id || '1');

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.opdPaymentUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response.data.status) {
      toast.success(response.data.message || 'Payment recorded');
      const newPaid = parseFloat(String(response.data.new_paid).replace(/[,]/g, ''));
      const newDue  = parseFloat(String(response.data.new_due).replace(/[,]/g, ''));
      setFormData(prev => ({
        ...prev,
        opd_paid: newPaid.toFixed(2),
        opd_due: newDue.toFixed(2),
      }));
      setLastSavedPaid(String(newPaid));
      setLastSavedDue(String(newDue));
      setPaymentAmount('');
      setShowPaymentModal(false);
      fetchOpdPaymentHistory(formData.opd_id);
    } else {
      toast.error(response.data.message || 'Failed to add payment');
    }
  } catch (error) {
    console.error("Payment error:", error);
    toast.error("Failed to add payment. Please try again.");
  }
};


   // helper to produce a display string (e.g. "2Y 3M 5D")
   // format numeric age parts into "1 Year 2 Months 3 Days" (only includes non-zero parts)
const formatAgeFromParts = (years, months, days) => {
  // Accept numbers or numeric strings; treat '', null, undefined as 0
  const y = (years === '' || years === null || years === undefined) ? 0 : Number(years) || 0;
  const m = (months === '' || months === null || months === undefined) ? 0 : Number(months) || 0;
  const d = (days === '' || days === null || days === undefined) ? 0 : Number(days) || 0;

  const parts = [];
  if (y > 0) parts.push(`${y} ${y === 1 ? 'Year' : 'Years'}`);
  if (m > 0) parts.push(`${m} ${m === 1 ? 'Month' : 'Months'}`);
  if (d > 0) parts.push(`${d} ${d === 1 ? 'Day' : 'Days'}`);

  // If all parts zero, return empty string (so caller can fallback to 'N/A' or nothing)
  return parts.length ? parts.join(' ') : '';
};

// map speciality & doctor arrays to react-select-friendly options


// react-select handlers


  const specRef = useRef();
  const docRef = useRef();
     const [showOtherDetails, setShowOtherDetails] = useState(false);
    const [formData, setFormData] = useState({
        tests: [],
        vitals: [],
        cats:[],
        tests1: [
            {
                sn: 1,
                opd_val_name: '',
                opd_val_value: '',
            }
        ],
        comps: [
            {
                sn: 1,
                comp_name: ''
            }
        ],
        inspections: [  
            {
                sn: 1,
                insp_name: ''
            }
        ],

        docs: [],
        opd_token_no: '',
        opd_id: '',
        opd_uhid: '',
        opd_patient_title: 'Mr.',
        opd_patient_name: '',
        opd_patient_gender: 'Male',
        opd_patient_mobile: '',
        opd_guardien_age: '',
        opd_guardien_title: '',
        opd_guardien_name: '',
        opd_address: '',
        opd_city: '',
        opd_state: '',
        opd_type: 'New Visit',
        opd_specality: '',
        opd_concult_doctor: '',
        opd_datetime: "",
        opd_total: '0',
        opd_fees: '0',
        opd_reg_fees: '0',
        opd_discount: '0',
        opd_final_amt: '0',
        opd_paid: '0',
        opd_mode: '',
        opd_remark: '',
        opd_due: '0',
        opd_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        opd_discount_amt: '0', 

        opd_broker_id: '',
opd_broker_name: '',
opd_broker_commission: '0',
opd_broker_commission_type: 'fixed',
        isAlert: false,
    });






    
// Load history + prefill received-by whenever we have a saved opd_id
useEffect(() => {
  if (formData.opd_id) {
    fetchOpdPaymentHistory(formData.opd_id);
    setPaymentReceivedBy(Name);
  }
}, [formData.opd_id]);
// Modify your main useEffect
useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    
    // === MODIFIED PART: Set the next token automatically ===
    

    setFormData(prev => ({
        ...prev,
        opd_datetime: formattedDate,
        opd_token_no: '', // We add a new field in state for the token
    }));
    // ========================================================

    console.log('Component mounted');
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
        const parsed = JSON.parse(storedData);
        setLdata(parsed);
        initData(); // Your existing function
    }

    // ... your other logic for loading from sessionStorage
}, []);




useEffect(() => {
  let gtotal = 0.0;

  const fees = parseFloat(formData.opd_fees) || 0;
  const regFees = parseFloat(formData.opd_reg_fees) || 0;
  gtotal = fees + regFees;

  // Apply percentage discount if any
  if (formData.opd_discount) {
      const dis = parseFloat(formData.opd_discount) || 0;
      gtotal = gtotal - (gtotal * dis) / 100;
  }

  // Apply fixed discount amount if any
  if (formData.opd_discount_amt) {
      const fixedDis = parseFloat(formData.opd_discount_amt) || 0;
      gtotal = gtotal - fixedDis;
  }

  // Ensure gtotal doesn't go negative
  if (gtotal < 0) gtotal = 0;

  const paid = parseFloat(formData.opd_paid) || 0;
  const due = gtotal - paid;

  setFormData(prev => ({
      ...prev,
      opd_total: (fees + regFees) + "",     // total before discount
      opd_final_amt: gtotal + "",           // after discount
      opd_due: due + "",                    // final due after payment
  }));
}, [formData.opd_fees, formData.opd_reg_fees, formData.opd_discount, formData.opd_discount_amt, formData.opd_paid]);

const UPPERCASE_FIELDS = new Set([
  'opd_patient_name',
  'opd_guardien_name',
  'opd_address',
  'opd_city',
  'opd_state', 
  'opd_remark',
]);





const handleChange = (e) => {
    
    let { name, value } = e.target;

    // force uppercase for selected text fields only
    if (UPPERCASE_FIELDS.has(name) && typeof value === 'string') {
        value = value.toUpperCase();
    }
    if (name === "opd_paid") {
        // Paid change -> update due immediately
        const paid = parseFloat(value) || 0;
        const fees = parseFloat(formData.opd_fees) || 0;
        const regFees = parseFloat(formData.opd_reg_fees) || 0;
        let gtotal = fees + regFees;
        if (formData.opd_discount) {
            const dis = parseFloat(formData.opd_discount) || 0;
            gtotal = gtotal - (gtotal * dis) / 100;
        }
        const due = gtotal - paid;

        setFormData(prev => ({
            ...prev,
            [name]: value,
            opd_due: due + "",
        }));
        return;
    }

    if (name === "opd_patient_title") {
      let gender = "";
      if (value === "Mr." || value === "Master") {
          gender = "Male";
      } else if (value === "Miss" || value === "Mr's") {
          gender = "Female";
      } else {
          // Baby / B/O → keep existing gender, don't wipe it
          gender = formData.opd_patient_gender || "Male";
      }
      setFormData(prev => ({
          ...prev,
          [name]: value,
          opd_patient_gender: gender,
      }));
      return;   // (the `if (name === "search_key")` line below was dead code — never true here)
  }


    setFormData(prev => ({
        ...prev,
        [name]: value,
    }));

      setIsSaved(false);
};





const handleSubmit = async (e) => {
  e.preventDefault();
  
  const fd = new FormData();

  var items = formData.tests1;
  for (var x = 0; x < items.length; x++) {
      const el1 = document.getElementById("vital45" + x);
      const el2 = document.getElementById("vitalval45" + x);
      items[x].opd_val_name = el1 ? el1.value : '';
      items[x].opd_val_value = el2 ? el2.value : '';
  }

  var items1 = formData.comps;
  for (var x = 0; x < items1.length; x++) {
      const el = document.getElementById("comp_txt" + x);
      items1[x].comp_name = el ? el.value : '';
  }

  var inspItems = formData.inspections;
  for (var x = 0; x < inspItems.length; x++) {
      const el = document.getElementById("insp_txt" + x);
      inspItems[x].insp_name = el ? el.value : '';
  }

  const buildCombinedAge = (y, m, d) => {
      const parts = [];
      if (y !== '' && Number(y) > 0) parts.push(`${Number(y)}Y`);
      if (m !== '' && Number(m) > 0) parts.push(`${Number(m)}M`);
      if (d !== '' && Number(d) > 0) parts.push(`${Number(d)}D`);
      return parts.length ? parts.join(' ') : (y ? String(Number(y)) : '');
  };    

  const combinedAge = buildCombinedAge(ageYears, ageMonths, ageDays);  
  
  // ✅ FIXED: Declare fullDateTime ONCE and update it with current time
  let fullDateTime = formData.opd_datetime;
if (!formData.opd_id && fullDateTime && fullDateTime.length >= 10) {
    const dateOnly = fullDateTime.split(' ')[0];
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    fullDateTime = `${dateOnly} ${hours}:${minutes}:${seconds}`;
}

  fd.append('opd_id', formData.opd_id);
  
  fd.append('opd_patient_title', formData.opd_patient_title);
  fd.append('opd_patient_name', formData.opd_patient_name);
  fd.append('opd_patient_gender', formData.opd_patient_gender);
  fd.append('opd_patient_mobile', formData.opd_patient_mobile);
  fd.append('opd_guardien_title', formData.opd_guardien_title);
  fd.append('opd_guardien_name', formData.opd_guardien_name);
  fd.append('opd_address', formData.opd_address);
  fd.append('opd_datetime', fullDateTime); // ✅ Uses the updated fullDateTime with current time
  fd.append('opd_guardien_age', combinedAge);
  fd.append('opd_guardien_years', ageYears === '' ? '' : ageYears);
  fd.append('opd_guardien_months', ageMonths === '' ? '' : ageMonths);
  fd.append('opd_guardien_days', ageDays === '' ? '' : ageDays);
  fd.append('opd_city', formData.opd_city);
  fd.append('opd_state', formData.opd_state || '');
  fd.append('opd_type', formData.opd_type);
  fd.append('opd_specality', formData.opd_specality);
  fd.append('opd_concult_doctor', formData.opd_concult_doctor);
  fd.append('opd_total', formData.opd_total);
  fd.append('opd_fees', formData.opd_fees);
  fd.append('opd_reg_fees', formData.opd_reg_fees);
  fd.append('opd_discount', formData.opd_discount);
  fd.append('opd_discount_amt', formData.opd_discount_amt);
  fd.append('opd_final_amt', formData.opd_final_amt);
  fd.append('opd_paid', formData.opd_paid);
  fd.append('opd_mode', formData.opd_mode);
  fd.append('opd_remark', formData.opd_remark);
  fd.append('opd_due', formData.opd_due);
  fd.append('opd_uhid', formData.opd_uhid);
  fd.append('opd_items', JSON.stringify(items) + "");
  fd.append('opd_comps', JSON.stringify(items1) + "");
  fd.append('opd_inspects', JSON.stringify(inspItems) + ""); 
  fd.append('opd_user', ldata.user_id);

  fd.append('opd_broker_id', formData.opd_broker_id || '');
fd.append('opd_broker_name', formData.opd_broker_name || '');
fd.append('opd_broker_commission', formData.opd_broker_commission || '0');
fd.append('opd_broker_commission_type', formData.opd_broker_commission_type || 'fixed');

  try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addOpdUrl, fd, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
      });

      if (response.data.status) {
        const backendUHID = response.data.opd_dt.opd_uhid;
        const backendID   = response.data.opd_dt.opd_id;
        const backendToken = response.data.opd_dt.opd_token_no;
    
        setFormData(prev => ({
            ...prev,
            opd_uhid:      backendUHID || prev.opd_uhid,
            opd_id:        backendID   || prev.opd_id,
            opd_token_no:  backendToken,
            opd_guardien_years:  response.data.opd_dt.opd_guardien_years  ?? prev.opd_guardien_years,
            opd_guardien_months: response.data.opd_dt.opd_guardien_months ?? prev.opd_guardien_months,
            opd_guardien_days:   response.data.opd_dt.opd_guardien_days   ?? prev.opd_guardien_days,
            opd_datetime:         response.data.opd_dt.opd_datetime || prev.opd_datetime,
            opd_datetime_display: response.data.opd_dt.opd_datetime
                ? response.data.opd_dt.opd_datetime.split(' ')[0]
                : prev.opd_datetime_display,
            isAlert:   true,
            alertMsg:  response.data.success,
            alertMsgTyp: response.data.type,
        }));
    
        // ── BOOK SLOT if user selected one ──────────────────────────────
        if (selectedSlot && backendID) {
            try {
                const slotFd = new FormData();
                slotFd.append('action',        'book_slot');
                slotFd.append('slot_id',       String(selectedSlot.slot_id));
                //slotFd.append('date',          formData.opd_datetime?.split(' ')[0] || new Date().toISOString().split('T')[0]);
                slotFd.append('date', slotDate || new Date().toISOString().split('T')[0]);
                slotFd.append('time',          selectedSlot.time);
                slotFd.append('opd_id',        String(backendID));
                slotFd.append('patient_uhid',  backendUHID || '');
                slotFd.append('patient_name',  formData.opd_patient_name || '');
                slotFd.append('created_by',    String(ldata?.user_id || '1'));
    
                const slotRes = await axios.post(
                    AppConst.BASE_URL + AppConst.doctorSlotUrl,
                    slotFd,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
    
                if (slotRes.data?.status) {
                    toast.success('✓ Slot booked: ' + selectedSlot.time_display);
                    setSelectedSlot(null);
                    // refresh slots to show updated availability
                    fetchDoctorSlots(formData.opd_concult_doctor);
                } else {
                    toast.warning('OPD saved but slot booking failed: ' + (slotRes.data?.message || 'Unknown'));
                }
            } catch (slotErr) {
                console.error('Slot booking error:', slotErr);
                toast.warning('OPD saved but slot booking failed');
            }
        }
        // ────────────────────────────────────────────────────────────────
    
        const savedPaid = response.data.opd_dt.opd_paid ?? formData.opd_paid ?? '0';
        const savedDue  = response.data.opd_dt.opd_due  ?? formData.opd_due  ?? '0';
        setLastSavedPaid(String(Number(savedPaid || 0)));
        setLastSavedDue(String(Number(savedDue   || 0)));
        setIsSaved(true);
        const noFees =
  (parseFloat(formData.opd_reg_fees) || 0) === 0 &&
  (parseFloat(formData.opd_fees) || 0) === 0;
if (noFees) setShowActionModal(true);
    
// ✅ AUDIT LOG: If this was an EDIT (not new), log it
if (formData.opd_id && originalRecord) {
  try {
      const logFd = new FormData();
      logFd.append('record_id', formData.opd_id);
      logFd.append('old_data', JSON.stringify(originalRecord));
      logFd.append('remarks', 'OPD record updated');
      attachUserInfo(logFd);
      
      await axios.post(
          AppConst.BASE_URL + AppConst.logEditOpdUrl,
          logFd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      console.log("✅ OPD edit logged");
  } catch (logErr) {
      console.warn("⚠️ Audit log failed (non-critical):", logErr);
  }
}

        // WhatsApp status
        if (response.data.whatsapp_status === 'sent') {
            toast.success('✅ Registration successful! SMS sent to patient.');
        } else if (response.data.whatsapp_status === 'failed') {
            toast.warning(`⚠️ Registration successful, but SMS failed: ${response.data.whatsapp_message}`);
        } else if (response.data.whatsapp_status === 'error') {
            toast.error(`❌ Registration successful, but SMS error: ${response.data.whatsapp_message}`);
        } else if (response.data.whatsapp_status === 'disabled') {
            toast.info('✓ Registration successful');
        } else {
            toast.success('✓ Registration Success');
        }
    
        sessionStorage.removeItem("opd_dt");
    }
      else {
          setFormData(prev => ({
              ...prev,
              isAlert: true,
              alertMsg: response.data.success,
              alertMsgTyp: response.data.type,
          }));
          toast.error('❌ Registration failed');
      }
  } catch (error) {
      console.error('Submit Error:', error);
      setFormData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: "Failed",
          alertMsgTyp: "danger",
      }));
      toast.error('❌ Server error occurred');
  }
};

const initData1 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);

             const fd2 = new FormData();
            fd2.append('type', "doctor");
            fd2.append('search_key', "");
            fd2.append('page_no', "none");
            fd2.append('doc_specality', formData.opd_specality);
            fd2.append('user_cre_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            docs: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    }
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.tests1.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                tests1: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }


           

            const fd0 = new FormData();
            fd0.append('cat_type', "speciality");
            fd0.append('page_no', "none");
            fd0.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd0, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                });
                if (response.data.status) {

                var records = response.data.records;
                if (records != null && records != undefined) {
                    setFormData(prev => ({
                    ...prev,
                    cats: records
                    }));
                }
                }
            } catch (error) {

            }

            const fd00 = new FormData();
fd00.append('cat_type', "hospCharge");
fd00.append('cat_name', "Opd Fees");
fd00.append('page_no', "none");
fd00.append('par_by', 1 + "");

try {
    const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd00, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    
    if (response.data.status) {
        var records = response.data.records;
        
        if (records != null && records != undefined && records.length > 0) {
            // ✅ Filter for exact match instead of using records[1]
            const opdFeesRecord = records.find(record => 
                record.cat_name === "Opd Fees" || 
                record.cat_name.toLowerCase() === "opd fees"
            );
            
            if (opdFeesRecord) {
              setDefaultRegFees(opdFeesRecord.cat_type1);          // remember original
              setFormData(prev => ({
                  ...prev,
                  opd_reg_fees: prev.opd_type === 'Old'
                      ? '0'
                      : opdFeesRecord.cat_type1
              }));
          } else {
              console.warn('OPD Fees record not found in response');
          }
        }
    }
} catch (error) {
    console.error('Error loading OPD Fees:', error);
}

              
        }
    };

    const loadBrokers = async () => {
      try {
        const fd = new FormData();
        fd.append('search_key', '');
        fd.append('page_no', 'none');
        //fd.append('limit', '500');
        const res = await axios.post(
          AppConst.BASE_URL + AppConst.getBrokerListUrl, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (res.data?.status) setBrokers(res.data.records || []);
      } catch (err) { console.error('loadBrokers error', err); }
    };

    useEffect(() => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const hours = String(today.getHours()).padStart(2, '0');
      const minutes = String(today.getMinutes()).padStart(2, '0');
      const seconds = String(today.getSeconds()).padStart(2, '0');
      
      // Store as "YYYY-MM-DD HH:MM:SS" for backend, but display as date only
      const fullDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const formatted = `${year}-${month}-${day}`;
      const dateOnly = `${year}-${month}-${day}`;
      
      setFormData(prev => ({
          ...prev,
          opd_datetime: fullDateTime, // ✅ Store full datetime
          opd_datetime_display: dateOnly // ✅ For display in input field
      }));


        //console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {
              setOriginalRecord(tmp);
// if (tmp.opd_concult_doctor) {
//                     updateTokenForDoctor(tmp.opd_concult_doctor);
//                 }


// populate numeric age inputs when editing existing record
const parsed = parseAgeString(tmp.opd_guardien_age, tmp.opd_guardien_years, tmp.opd_guardien_months, tmp.opd_guardien_days);
setAgeYears(parsed.y);
setAgeMonths(parsed.m);
setAgeDays(parsed.d);

                var items = tmp.items;
                var items1 = tmp.items1;

                setFormData(prev => ({
                    ...prev,
                    tests1: items,
                    comps: items1,
                    opd_id: tmp.opd_id,
                    opd_token_no: tmp.opd_token_no,
                    opd_patient_title: tmp.opd_patient_title,
                    opd_patient_name: tmp.opd_patient_name,
                    opd_patient_gender: tmp.opd_patient_gender,
                    opd_patient_mobile: tmp.opd_patient_mobile,
                    opd_guardien_title: tmp.opd_guardien_title,
                    opd_guardien_name: tmp.opd_guardien_name,
                    opd_address: tmp.opd_address,
                    opd_city: tmp.opd_city,
                    opd_state: tmp.opd_state || '',
                    opd_type: tmp.opd_type,
                    opd_specality: tmp.opd_specality,
                    opd_concult_doctor: tmp.opd_concult_doctor,
                    opd_guardien_age: tmp.opd_guardien_age,
                    opd_total: tmp.opd_total,
                    opd_fees: tmp.opd_fees ? Number(tmp.opd_fees) : 0,
                    opd_reg_fees: tmp.opd_reg_fees ? Number(tmp.opd_reg_fees) : 0,
                    opd_discount: tmp.opd_discount ? Number(tmp.opd_discount) : 0,
                    opd_final_amt: tmp.opd_final_amt ? Number(tmp.opd_final_amt) : 0,
                    opd_paid: tmp.opd_paid ? Number(tmp.opd_paid) : 0,
                    opd_mode: tmp.opd_mode,
                    opd_discount_amt: tmp.opd_discount_amt ? Number(tmp.opd_discount_amt) : 0,
                    // opd_remark: tmp.opd_remark,
                     opd_due: tmp.opd_due ? Number(tmp.opd_due) : 0,
                    opd_user: tmp.opd_user,
                    opd_datetime: tmp.opd_datetime || prev.opd_datetime, // ✅ Keep full datetime from backend
                    opd_datetime_display: tmp.opd_datetime ? tmp.opd_datetime.split(' ')[0] : (prev.opd_datetime_display || formatted),

                }));
            }
        }



        return () => {
            //console.log('Component unmounted');
        };
    }, []);

      useEffect(() => {
        initData1();
    }, [formData.opd_specality]);


    // Old patient → no registration charge. New Visit → restore config fee.
useEffect(() => {
  setFormData(prev => ({
    ...prev,
    opd_reg_fees: prev.opd_type === 'Old' ? '0' : (defaultRegFees || '0')
  }));
}, [formData.opd_type, defaultRegFees]);

    useEffect(() => {
      fetchOpdFormat(formData.opd_specality);
    }, [formData.opd_specality]);
        // Add complaint row
    const addComplaint = () => {
        setFormData(prev => ({
            ...prev,
            comps: [
                ...prev.comps,
                {
                    sn: prev.comps.length + 1,
                    comp_name: ''
                }
            ]
        }));
    };

    // Remove complaint row
    const removeComplaint = (index) => {
        const newComps = [...formData.comps];
        newComps.splice(index, 1);
        setFormData(prev => ({
            ...prev,
            comps: newComps
        }));
    };

    // Add inspection row
    const addInspection = () => {
        setFormData(prev => ({
            ...prev,
            inspections: [
                ...prev.inspections,
                {
                    sn: prev.inspections.length + 1,
                    insp_name: ''
                }
            ]
        }));
    };

    // Remove inspection row
    const removeInspection = (index) => {
        const newInspections = [...formData.inspections];
        newInspections.splice(index, 1);
        setFormData(prev => ({
            ...prev,
            inspections: newInspections
        }));
    };

const searchUserNow = async (e) => {
  const uhid = e.target.value.trim();

  if (uhid.length < 3) { // thoda fast search ke liye 3 char ke baad call
    setUhidSuggestions([]);
    return;
  }

  try {
    const fd = new FormData();
    fd.append("lab_reg_uhid", uhid);

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.searchUhidUrlCall,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (response.data.status) {
      setUhidSuggestions(response.data.records || []);
    } else {
      setUhidSuggestions([]);
    }
  } catch (error) {
    console.error("Search Error:", error);
    setUhidSuggestions([]);
  }
};


const handleSelUser = (lab_reg_dt) => {
  if (!lab_reg_dt) return;

  // ✅ Directly use the data from clicked suggestion
  const details = lab_reg_dt;
  
  const patientName = details.lab_reg_name || '';
  const patientTitle = details.lab_reg_name_title || 'Mr.';
  const patientGender = details.lab_reg_gender || '';
  const patientMobile = details.lab_reg_mobile || '';
  const patientAddress = details.lab_reg_address || '';
  const patientCity = details.lab_reg_city || '';
  const guardianName = details.lab_guardian_name || '';
  const guardianTitle = details.opd_guardien_title || 'C/O';
  const uhid = details.lab_reg_uhid || '';
  
  // Age fields
  const ageYear = details.lab_reg_age_year || '';
  const ageMonth = details.lab_reg_age_month || '';
  const ageDay = details.lab_reg_age_day || '';

  // Update age state variables
  setAgeYears(ageYear ? String(Number(ageYear)) : '');
  setAgeMonths(ageMonth ? String(Number(ageMonth)) : '');
  setAgeDays(ageDay ? String(Number(ageDay)) : '');

  setFormData(prev => ({
    ...prev,
    opd_type: 'Old',
    opd_uhid: uhid,
    opd_patient_title: patientTitle,
    opd_patient_name: patientName,
    opd_patient_gender: patientGender,
    opd_patient_mobile: patientMobile,
    opd_address: patientAddress,
    opd_city: patientCity,
    opd_guardien_name: guardianName,
    opd_guardien_title: guardianTitle,
    opd_guardien_years: ageYear,
    opd_guardien_months: ageMonth,
    opd_guardien_days: ageDay,
  }));

  toast.success("Patient data loaded successfully");
  setUhidSuggestions([]); // Close suggestion list
};


const runOpdPatientSearch = async (params) => {
  setOpdSearchLoading(true);
  try {
      const fd = new FormData();
      Object.entries(params).forEach(([k, v]) => fd.append(k, v));
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      if (!response.data.status) { toast.error('No patient found'); return; }
      const records = response.data.records || [];
      if (records.length === 0) { toast.error('No patient found'); return; }
      if (records.length === 1) {
          applyOpdPatient(records[0]);
      } else {
          setOpdPatientResults(records);
          setShowOpdPatientModal(true);
      }
  } catch (err) {
      toast.error('Error searching patient');
  } finally {
      setOpdSearchLoading(false);
  }
};


// ✅ Smart unified search — auto-detects type and debounces
const unifiedSearchRef = useRef(null);

const handleUnifiedSearch = (val) => {
  setOpdSearchInput(val);
  const trimmed = val.trim();

  // Clear previous debounce
  if (unifiedSearchRef.current) clearTimeout(unifiedSearchRef.current);

  // If cleared — clear suggestions
  if (trimmed.length === 0) {
    setUhidSuggestions([]);
    return;
  }

  // Detect input type
  const isPhone = /^[6-9]\d{9}$/.test(trimmed);           // 10-digit Indian mobile
  const isPartialPhone = /^\d+$/.test(trimmed);           // pure digits but not complete
  const isUhidLike = /^[A-Za-z]{1,3}\d+/.test(trimmed);   // e.g., "SH00028123"

  // Phone complete → trigger search immediately
  if (isPhone) {
    unifiedSearchRef.current = setTimeout(() => {
      runOpdPatientSearch({ lab_reg_mobile: trimmed });
    }, 300);
    return;
  }

  // Partial phone (< 10 digits) — don't search yet
  if (isPartialPhone && trimmed.length < 10) {
    setUhidSuggestions([]);
    return;
  }

  // UHID or name → show live suggestions (debounced)
  if (trimmed.length >= 3) {
    unifiedSearchRef.current = setTimeout(async () => {
      try {
        const fd = new FormData();
        // Send whatever looks most appropriate — backend can match any
        if (isUhidLike) {
          fd.append('lab_reg_uhid', trimmed);
        } else {
          // Treat as name — backend should support partial name match
          fd.append('lab_reg_name', trimmed);
        }
        const response = await axios.post(
          AppConst.BASE_URL + AppConst.searchUhidUrlCall,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        if (response.data.status) {
          setUhidSuggestions(response.data.records || []);
        } else {
          setUhidSuggestions([]);
        }
      } catch (err) {
        console.error('Search error:', err);
        setUhidSuggestions([]);
      }
    }, 400);
  } else {
    setUhidSuggestions([]);
  }
};


const applyOpdPatient = (details) => {
  const ageYear  = details.lab_reg_age_year  || '';
  const ageMonth = details.lab_reg_age_month || '';
  const ageDay   = details.lab_reg_age_day   || '';

  setAgeYears(ageYear   ? String(Number(ageYear))   : '');
  setAgeMonths(ageMonth ? String(Number(ageMonth)) : '');
  setAgeDays(ageDay     ? String(Number(ageDay))   : '');

  setFormData(prev => ({
      ...prev,
      opd_type:           'Old',
      opd_uhid:           details.lab_reg_uhid        || '',
      opd_patient_title:  details.lab_reg_name_title  || 'Mr.',
      opd_patient_name:   details.lab_reg_name        || '',
      opd_patient_gender: details.lab_reg_gender      || '',
      opd_patient_mobile: details.lab_reg_mobile      || '',
      opd_address:        details.lab_reg_address     || '',
      opd_city:           details.lab_reg_city        || '',
      opd_guardien_name:  details.lab_guardian_name   || '',
      opd_guardien_title: details.opd_guardien_title  || 'C/O',
      opd_guardien_years:  ageYear,
      opd_guardien_months: ageMonth,
      opd_guardien_days:   ageDay,
  }));

  setUhidSuggestions([]);
  setShowOpdPatientModal(false);
  setOpdSearchInput('');
  toast.success('Patient data loaded');
};

// Auto-search by phone (triggers after 10 digits)
const handlePhoneKeyUp = (e) => {
  const val = e.target.value.trim();
  setOpdPhoneSearch(val);
  if (val.length === 10) {
      runOpdPatientSearch({ lab_reg_mobile: val });
  }
};



     useEffect(() => {
    if (formData.opd_specality) {
      const filtered = formData.docs.filter(
        doc => doc.doc?.doc_specality === formData.opd_specality
      );
      setFilteredDoctors(filtered);
    } else {
      setFilteredDoctors(formData.docs);
    }
  }, [formData.opd_specality, formData.docs]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (specRef.current && !specRef.current.contains(event.target)) {
      setShowSpecOptions(false);
    }
    if (docRef.current && !docRef.current.contains(event.target)) {
      setShowDocOptions(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


// ✅ Helper to attach logged-in user info to any FormData
const attachUserInfo = (fd) => {
  try {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      const u = JSON.parse(stored);
      fd.append('user_id',   u.user_id   || '');
      fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
      fd.append('user_role', u.role_id   || u.role_name || '');
    }
  } catch (e) {
    console.warn("attachUserInfo failed:", e);
  }
  return fd;
};
 // map speciality & doctor arrays to react-select-friendly options
 const specialityOptions = (formData.cats || []).map(c => ({ value: c.cat_id, label: c.cat_name }));
 const doctorOptions = (filteredDoctors || []).map(d => ({ value: d.user_id, label: d.fname || '' }));


 const brokerOptions = (brokers || []).map(b => ({
  value: b.id || b.broker_id,
  label: `${b.fname || ''} ${b.lname || ''}`.trim() +
         (b.mobile ? ` (${b.mobile})` : '') +
         (b.lab_commission ? ` — ${b.lab_commission_type === 'percentage' ? b.lab_commission + '%' : '₹' + b.lab_commission}` : '')
}));



 // ✅ Refetch slots whenever appointment date changes (if doctor already selected)
useEffect(() => {
  if (formData.opd_concult_doctor) {
    setSelectedSlot(null); // clear previous selection
    fetchDoctorSlots(formData.opd_concult_doctor, slotDate);
  }
}, [slotDate]);
// react-select handlers
const handleSpecSelect = (option) => {
  setFormData(prev => ({
    ...prev,
    opd_specality: option ? option.value : '',
    opd_concult_doctor: '', // clear doctor on speciality change
    opd_fees: '0'
  }));
};

// ✅ REPLACE with this
const handleDocSelect = (option) => {
  if (!option) {
    setFormData(prev => ({
      ...prev,
      opd_concult_doctor: '',
      opd_fees: '0',
      opd_token_no: ''
    }));
    setDoctorSlots([]);
    setSelectedSlot(null);
    return;
  }
  const docId = option.value;
  const selectedDoc =
    filteredDoctors.find(d => String(d.user_id) === String(docId)) ||
    formData.docs.find(d => String(d.user_id) === String(docId)) ||
    null;

  // 👇 auto-pick the doctor's speciality
  const docSpec = selectedDoc?.doc?.doc_specality ?? '';

  setFormData(prev => ({
    ...prev,
    opd_concult_doctor: docId,
    opd_specality: docSpec || prev.opd_specality,   // 👈 auto speciality
    opd_fees: selectedDoc?.doc?.doc_fees || '0',
  }));

  fetchDoctorSlots(docId, slotDate);
};



const fetchDoctorSlots = async (doctorId, dateStr = null) => {
  if (!doctorId) return;
  const useDate = dateStr || slotDate || new Date().toISOString().split('T')[0];
  setSlotsLoading(true);
  try {
    const fd = new FormData();
    fd.append('action',    'get_doctor_slots_for_date');
    fd.append('doctor_id', String(doctorId));
    fd.append('date',      useDate);

    const res = await axios.post(
      AppConst.BASE_URL + AppConst.doctorSlotUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (res.data?.status) {
      setDoctorSlots(res.data.slots || []);
      if ((res.data.slots || []).length === 0 && res.data.unavailable_reason) {
        setSlotUnavailableReason(res.data.unavailable_reason);
      } else {
        setSlotUnavailableReason('');
      }
    } else {
      setDoctorSlots([]);
      setSlotUnavailableReason('');
    }
  } catch (err) {
    console.error('fetchDoctorSlots error:', err);
    setDoctorSlots([]);
  } finally {
    setSlotsLoading(false);
  }
};


useEffect(() => {
  if (formData?.opd_concult_doctor && filteredDoctors.length > 0) {
    const selectedDoc = filteredDoctors.find(
      doc => doc.user_id === formData.opd_concult_doctor
    );
    if (selectedDoc) {
      setDocSearch(selectedDoc.fname);
    }
  }
}, [formData.opd_concult_doctor, filteredDoctors]);


const isFormValid = () => {
  const requiredFields = [
    'opd_patient_name',
    'opd_specality',
    'opd_concult_doctor'
  ];

  return requiredFields.every(
    field =>
      formData[field] !== null &&
      formData[field] !== undefined &&
      String(formData[field]).trim() !== ''
  );
};

// console.log("this is formdata : " + JSON.stringify(formData))


// Modified fetchConfigData function
const fetchConfigData = async () => {
    try {
        const res = await axios.post(
            `${AppConst.BASE_URL + AppConst.getconfig}?config_type=opd`
        );
        if (res.data.status) {
          console.log(res.data)
            const data = res.data;
            // Use the new state setters
            setHeaderLogo( data.header_logo);
            setWatermarkLogo( data.logo || '');
            setFooterImage(data.footer_logo)
        }
    } catch (err) {
        console.error("Error fetching config:", err);
    }
};

// Modified useEffect to call it on component mount
useEffect(() => {
    fetchConfigData();
    loadBrokers();
    fetchOpdColumns();
}, []); // Empty dependency array ensures it runs only once

useEffect(() => {
  if (!selectedBroker) {
    setBrokerCommission(0);
    setFormData(prev => ({
      ...prev,
      opd_broker_id: '',
      opd_broker_name: '',
      opd_broker_commission: '0',
      opd_broker_commission_type: 'fixed'
    }));
    return;
  }

  const finalAmt = parseFloat(formData.opd_final_amt || 0);
  const type = (selectedBroker.opd_commission_type || 'fixed').toLowerCase();
  const val  = parseFloat(selectedBroker.opd_commission || 0);

  let commission = 0;
  if (val > 0 && finalAmt > 0) {
    commission = (type === 'percentage' || type === 'percent' || type === '%')
      ? (finalAmt * val) / 100
      : val;
  }

  setBrokerCommission(commission);
  setFormData(prev => ({
    ...prev,
    opd_broker_id: selectedBroker.id || selectedBroker.broker_id || '',
    opd_broker_name: `${selectedBroker.fname || ''} ${selectedBroker.lname || ''}`.trim(),
    opd_broker_commission: commission.toFixed(2),
    opd_broker_commission_type: type
  }));
}, [selectedBroker, formData.opd_final_amt]);

const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
        const response = await fetch(url);
        if (!response.ok) return null;
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        //console.error("Error converting image to Base64:", error);
        return null;
    }
};
// Add this helper function inside your component
const numberToWords = (num) => {
    if (num === undefined || num === null || num === '') return '';

    num = Number(num); // convert to number
    if (isNaN(num)) return '';

    // Round to nearest integer (no paisa words)
    num = Math.round(num);

    const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    if (num.toString().length > 9) return 'overflow';

    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';

    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';

    return str.charAt(0).toUpperCase() + str.slice(1).trim();
};

// simple parser for "23 Years 5 Months 10 Days" OR numeric parts from backend
const parseAgeString = (ageStr, yearsField, monthsField, daysField) => {
  // prefer explicit numeric fields if provided
  if (yearsField !== undefined || monthsField !== undefined || daysField !== undefined) {
    return {
      y: yearsField ? String(Number(yearsField)) : '',
      m: monthsField ? String(Number(monthsField)) : '',
      d: daysField ? String(Number(daysField)) : ''
    };
  }
  if (!ageStr) return { y: '', m: '', d: '' };
  const y = (ageStr.match(/(\d+)\s*(?:Year|Y)/i) || [])[1] || '';
  const m = (ageStr.match(/(\d+)\s*(?:Month|M)/i) || [])[1] || '';
  const d = (ageStr.match(/(\d+)\s*(?:Day|D)/i) || [])[1] || '';
  return { y: y ? String(Number(y)) : '', m: m ? String(Number(m)) : '', d: d ? String(Number(d)) : '' };
};



const generateInvoicePdf = async (invoiceData , type) => {
    if (!invoiceData) {
        toast.error("No invoice data available to generate PDF.");
        return;
    }


    const doc = new jsPDF('p', 'pt', 'a4');

    if (type === 'header') {
      const headerImageBase64 = await imageUrlToBase64(headerLogo);
      if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, 600, 80);
      }
    }
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // ================= A. Load Images =================
    const headerImageBase64 = await imageUrlToBase64(invoiceData.config.headerLogoUrl);
    const watermarkImageBase64 = await imageUrlToBase64(invoiceData.config.watermarkLogoUrl);

    // ================= B. Header Logo Bar =================
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    // ================= C. Invoice Heading Box =================
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setDrawColor(0);
    doc.rect(40, 90, pageWidth - 80, 25); // box
    doc.text("OPD Receipt", pageWidth / 2, 107, { align: 'center' });

    // ================= D. Patient & Bill Details =================
    const leftX = 50;
    const rightX = pageWidth / 2 + 20;
    let y = 140;

    const printDetail = (label, value, x, y) => {
        doc.setFont('helvetica', 'normal');
        doc.text(`${label} :`, x, y);
        doc.setFont('helvetica', 'normal');
        doc.text(`${value || ''}`, x + 85, y);
    };

    console.log(invoiceData)

    // Left side
    printDetail("UHID No", invoiceData.patient.uhid, leftX, y);
    printDetail("Patient Name", invoiceData.patient.name, leftX, y += 13);
    printDetail("Guardian", `${invoiceData.patient.guardianName}`, leftX, y += 13);
    printDetail("Patient Address", invoiceData.patient.address, leftX, y += 13);
    printDetail("Payment Method", invoiceData.payment.method, leftX, y += 13);

    // Right side
    y = 140;
    printDetail("Bill Date", invoiceData.bill.date, rightX, y);
    printDetail("Age/Sex", invoiceData.patient.ageSex, rightX, y += 13);
    printDetail("Token No", invoiceData.bill.token, rightX, y += 13);
    printDetail("Receipt No", invoiceData.bill.receiptNo, rightX, y += 13);
    printDetail("Visit Date", invoiceData.bill.visitDate, rightX, y += 13);
    // printDetail("Opd No", invoiceData.bill.opdNo, rightX, y += 15);

    // ================= E. Transaction History =================
// ================= E. Transaction History Heading =================
// ===== Transaction History Heading =====
// doc.setFont('helvetica', 'bold');
// doc.setFontSize(12);
// doc.text("Transaction History", 50, y + 10); // thoda upar ki taraf

// ===== Table =====
autoTable(doc, {
  startY: y + 15, // upar ka gap badha diya
  head: [['S.No', 'Doctor Name', 'Amount']],
  body: invoiceData.transactions.map(tx => [
      tx.sno || '',
      tx.description || '',
      tx.amount ? tx.amount.toFixed(2) : '0.00'
  ]),
  theme: 'grid',
  headStyles: {
      fillColor: [255, 255, 255], // white like screenshot
      textColor: 0,
      fontStyle: 'bold',
      lineWidth: 0.1,
      lineColor:0
  },
  styles: {
    fontSize: 10,
    cellPadding: 5,
    textColor: 0,
    lineColor: [0, 0, 0],        // body border black
  lineWidth: 0.3               // <-- ensures all body + table text is black
  },
  columnStyles: {
      0: { cellWidth: 40, halign: 'center' },
      1: { cellWidth: pageWidth - 200 },
      2: { cellWidth: 80, halign: 'right' }
  },
  margin: { left: 40, right: 40 }
});

let finalY = doc.lastAutoTable.finalY + 10; // niche ka gap bhi add kiya



    // ================= F. Charges Summary =================
    const labelX = pageWidth - 250;
    const colonX = pageWidth - 120;
    const valueX = pageWidth - 60;

    const printSummaryLine = (label, value) => {
        finalY += 18;
        doc.setFont('helvetica', 'normal');
        doc.text(label, labelX, finalY);
        doc.text(':', colonX, finalY);
        doc.setFont('helvetica', 'bold');
        doc.text(value, valueX, finalY, { align: 'right' });
    };

    printSummaryLine("Registration Charges", invoiceData.summary.regCharges.toFixed(2));
    printSummaryLine("Bill Amount (Round Off)", invoiceData.summary.billAmount.toFixed(2));
    printSummaryLine("Discount (%)", invoiceData.summary.discount.toFixed(0));
    printSummaryLine("Paid", invoiceData.summary.paid.toFixed(2));
    printSummaryLine("Due", invoiceData.summary.due.toFixed(2));

    // ================= G. Sum in Words =================
   // ================= G. Sum in Words =================
// ================= G. Sum in Words =================
finalY += 25;
doc.setFont('helvetica', 'normal');

// Get logged-in user's name
const preparedByName = ldata?.fname 
    ? `${ldata.fname} ${ldata.lname || ''}`.trim() 
    : (ldata?.user_name || 'Admin');

// Prepared By on one line
doc.text(`Prepared By: ${preparedByName}`, 40, finalY);

// Add gap and then amount on next line
finalY += 15; // ✅ This creates the gap
doc.text(`Sum of Rs. ${invoiceData.summary.totalInWords} only Received`, 40, finalY);

    // ================= H. Watermark =================
    // if (watermarkImageBase64) {
    //     doc.setGState(new doc.GState({ opacity: 0.08 }));
    //     const wmSize = 300;
    //     doc.addImage(watermarkImageBase64, 'PNG',
    //         (pageWidth - wmSize) / 2,
    //         (pageHeight - wmSize) / 2,
    //         wmSize, wmSize
    //     );
    //     doc.setGState(new doc.GState({ opacity: 1 }));
    // }

    // ================= I. Signature =================
    // doc.text("Authorized Signature", pageWidth - 40, pageHeight - 80, { align: 'right' });
    // doc.text("SHRC ADMIN", pageWidth - 40, pageHeight - 65, { align: 'right' });

  
// ===== Full-width Footer Image =====
// const footerImgHeight = 40;
// doc.addImage(
//     footerImage,   // Base64 ya URL image variable
//     'PNG',       // format
//     0,           // X start (left edge)
//     pageHeight - footerImgHeight, // Y position (bottom se upar)
//     pageWidth,   // full page width
//     footerImgHeight // fixed height
// );


    // ================= K. Open PDF =================
    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
};


const handlePrint = (type) => {
  const selectedDoctor = formData.docs.find(d => d.user_id === formData.opd_concult_doctor) || null;

  const doctorName = selectedDoctor ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''}`.trim() : 'N/A';
  const docMeta = selectedDoctor?.doc || {};
  const doctorDesignationAndSpec = renderDesignationAndSpeciality(docMeta);
  const doctorSpeciality = getSpecialityName(docMeta?.doc_specality || docMeta?.doc_speciality || '');
  const doctorRegNo = (docMeta?.doc_reg_number || docMeta?.doc_reg_no || '').toString() || doctorSpeciality || 'N/A';
  const doctorDescription = doctorName === 'N/A'
    ? (doctorDesignationAndSpec || doctorSpeciality || 'N/A')
    : `${doctorName}${doctorDesignationAndSpec ? ' — ' + doctorDesignationAndSpec : ''}`;
  
  const token = formData.opd_token_no;
  const patientNameForReceipt = formData.opd_patient_name.replace(/ /g, '');
  const timeStamp = Date.now();

  const dynamicBillNo = `${timeStamp}-${token}`;
  const dynamicReceiptNo = `${patientNameForReceipt}-${token}`;
  
  // ✅ FIX: Get actual datetime from formData or use current time
  const actualDateTime = formData.opd_datetime || new Date().toISOString();
  const formattedDateTime = formatDateTimeForReceipt(actualDateTime);
  
  const formattedAge = formatAgeFromParts(
    formData.opd_guardien_years ?? formData.opd_guardien_years, 
    formData.opd_guardien_months ?? formData.opd_guardien_months, 
    formData.opd_guardien_days ?? formData.opd_guardien_days
  );
  const ageDisplay = formattedAge || (formData.opd_guardien_age ? String(formData.opd_guardien_age).trim() : 'N/A');
  
  const invoiceData = {
    config: { headerLogoUrl: headerLogo, watermarkLogoUrl: watermarkLogo },
    patient: {
      uhid: formData.opd_uhid || 'N/A',
      name: `${formData.opd_patient_title} ${formData.opd_patient_name}`.trim(),
      ageSex: `${ageDisplay} / ${formData.opd_patient_gender || 'N/A'}`,
      address: formData.opd_address || '',
      guardianTitle: formData.opd_guardien_title || '',  // ✅ Add this
      guardianName: formData.opd_guardien_name || '', 
    },
    payment: { method: formData.opd_mode },
    bill: {
      date: formattedDateTime,           // ✅ Same formatted time
      no: dynamicBillNo,
      token: token,
      receiptNo: dynamicReceiptNo,
      visitDate: formattedDateTime,      // ✅ Same formatted time
      opdNo: formData.opd_id || 'N/A',
    },
    transactions: [
      {
        sno: 1,
        description: `${doctorName}${selectedDoctor?.doc?.doc_degree ? ` (${selectedDoctor.doc.doc_degree})` : ''}${doctorSpeciality ? ` - ${doctorSpeciality}` : ''}`,
        amount: parseFloat(formData.opd_fees || 0)
      }
    ],
    summary: {
      regCharges: parseFloat(formData.opd_reg_fees || 0),
      billAmount: parseFloat(formData.opd_total || 0),
      discount: parseFloat(formData.opd_discount || 0),
      paid: parseFloat(formData.opd_paid || 0),
      due: parseFloat(formData.opd_due || 0),
      totalInWords: numberToWords(formData.opd_final_amt || 0)
    }
  };

  generateInvoicePdf(invoiceData, invoiceData);
};

const generatePrescriptionPdf = async (prescriptionData, type) => {
  if (!prescriptionData) {
      //console.error("No prescription data available to generate PDF.");
      return;
  }

  const doc = new jsPDF('p', 'pt', 'a4');

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 40;

  // ================= A. Header Logo =================
  if (type === 'header' || type === undefined) {
      const headerImageBase64 = await imageUrlToBase64(prescriptionData.config.headerLogoUrl);
      if (headerImageBase64) {
          doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
      }
  }

  // ================= B. Prescription Heading Box =================
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setDrawColor(0);
  doc.setLineWidth(1.5);
  doc.rect(margin, 90, pageWidth - (margin * 2), 25);
  doc.text("OPD PRESCRIPTION", pageWidth / 2, 107, { align: 'center' });

  // ================= C. Patient & Visit Details =================
  let y = 135;
  const rowHeight = 18;
  const labelWidth = 65;

  const printDetail = (label, value, x, yPos) => {
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text(label, x, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(`:  ${value || ''}`, x + labelWidth, yPos);
  };

  const col1X = margin + 5;
  const col2X = margin + 220;
  const col3X = margin + 380;

  printDetail("UHID No", prescriptionData.patient.uhid, col1X, y);
  printDetail("OPD No", prescriptionData.bill.opdNo, col2X, y);
  printDetail("Date", prescriptionData.bill.date, col3X, y);
  y += rowHeight;

  printDetail("Name", prescriptionData.patient.name, col1X, y);
  printDetail("Age", prescriptionData.patient.age, col2X, y);
  printDetail("Sex", prescriptionData.patient.sex, col3X, y);
  y += rowHeight;

  printDetail("Guardian", `${prescriptionData.patient.guardianName}`, col1X, y);
  printDetail("Mobile No", prescriptionData.patient.mobile, col2X, y);
  y += rowHeight;

  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.text("Doctor", col1X, y);
  doc.setFont('helvetica', 'normal');
  const doctorDetails = doc.splitTextToSize(`:  ${prescriptionData.doctor.name || ''} (${prescriptionData.doctor.degree}) (${prescriptionData.doctor.speciality})`, 600);
  doc.text(doctorDetails, col1X + labelWidth, y);
  printDetail("Doctor Reg No", prescriptionData.doctor.regNo, col3X, y);

  y += rowHeight; // thoda neeche line ke liye
  doc.setLineWidth(0.8);
  doc.line(0, y, pageWidth, y);   // Horizontal line full width

  // ================= D. Main Content Area =================
  let contentStartY = y + 30;
  const leftSectionWidth = 150;

  // Reserve space at the bottom for the footer so content never overlaps it
  const footerHeight = 90;
  const contentBottomY = pageHeight - margin - footerHeight;

  // Vertical divider (horizontal line se hi start karega)
  doc.setLineWidth(1.5);
  doc.line(leftSectionWidth, y, leftSectionWidth, contentBottomY);

  // // Horizontal dividers
  const historyY = contentStartY + 120;
  const adviceY = historyY + 260;
  doc.setLineWidth(0.5);
  doc.line(margin, historyY, leftSectionWidth, historyY);
  doc.line(margin, adviceY, leftSectionWidth, adviceY);

  // // Section Titles
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.text("VITALS :", margin + 5, contentStartY + 1);
  doc.text("Complaint :", margin + 5, historyY + 15);
  doc.text("Instruction : ", margin + 5, adviceY + 15);

  // Rx Section
  doc.setFontSize(22);
  doc.setFont('times', 'bold');
  doc.text("Rx", leftSectionWidth + 15, contentStartY + 5);

  // ================= F. Vitals, Complaints, Inspections =================
  const leftColX = margin + 5;
  const leftColWidth = leftSectionWidth - 10;
  const itemFontSize = 8;
  doc.setFontSize(itemFontSize);
  doc.setFont('helvetica', 'normal');

  // // --- 1. Vitals Data ---
  let vitalsY = contentStartY + 15;
  if (formData.tests1 && formData.tests1.length > 0) {
      formData.tests1.forEach((item, idx) => {
          const vitalName = document.getElementById(`vital45${idx}`)?.selectedOptions[0]?.text || '';
          const vitalValue = document.getElementById(`vitalval45${idx}`)?.value || '';
          const text = `${idx + 1}. ${vitalName} ${vitalValue}`;
          const wrappedText = doc.splitTextToSize(text, leftColWidth);

          if (vitalsY + (wrappedText.length * (itemFontSize + 2)) < historyY) {
              doc.text(wrappedText, leftColX, vitalsY);
              vitalsY += wrappedText.length * (itemFontSize + 2);
          }
      });
  }

  // // --- 2. Complaints Data ---
  let complaintsY = historyY + 30;
  if (formData.comps && formData.comps.length > 0) {
      formData.comps.forEach((item, idx) => {
          const compText = document.getElementById(`comp_txt${idx}`)?.value || '';
          const text = `${idx + 1}. ${compText}`;
          const wrappedText = doc.splitTextToSize(text, leftColWidth);

          if (complaintsY + (wrappedText.length * (itemFontSize + 2)) < adviceY) {
              doc.text(wrappedText, leftColX, complaintsY);
              complaintsY += wrappedText.length * (itemFontSize + 2);
          }
      });
  }

  // // --- 3. Instructions Data ---
  let instructionsY = adviceY + 30;
  if (formData.inspections && formData.inspections.length > 0) {
      formData.inspections.forEach((item, idx) => {
          const inspText = document.getElementById(`insp_txt${idx}`)?.value || '';
          const text = `${idx + 1}. ${inspText}`;
          const wrappedText = doc.splitTextToSize(text, leftColWidth);

          doc.text(wrappedText, leftColX, instructionsY);
          instructionsY += wrappedText.length * (itemFontSize + 2);
      });
  }

  
  // ================= G. Footer =================
const footerImageBase64 = await imageUrlToBase64(prescriptionData.config.footer_logo);
if (footerImageBase64) {
    doc.addImage(footerImageBase64, 'PNG', 0, pageHeight - 60, pageWidth, 60);
}

  // ================= H. Open PDF =================
  const pdfBlobUrl = doc.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};




const handlePrintPrescription = (type) => {
  const selectedDoctor = formData.docs.find(doc => doc.user_id === formData.opd_concult_doctor);
  const doctorDescription = selectedDoctor
    ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''} (${selectedDoctor.doc?.doc_degree || ''}, ${selectedDoctor.doc?.doc_specality || ''})`
    : 'N/A';
  const doctorRegNo = selectedDoctor ? selectedDoctor.doc?.doc_reg_number || selectedDoctor.doc?.doc_specality : selectedDoctor.doc?.doc_specality;
  
  // ✅ FIX: Get actual datetime
  const actualDateTime = formData.opd_datetime || new Date().toISOString();
  const formattedDateTime = formatDateTimeForReceipt(actualDateTime);
  
  const timeStamp = Date.now();
  const dynamicBillNo = `${timeStamp}`;
  
  const parsedAge = parseAgeString(formData.opd_guardien_age);
  const doctorName = selectedDoctor ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''}`.trim() : 'N/A';
  const doctorSpeciality = getSpecialityName(selectedDoctor?.doc?.doc_specality || selectedDoctor?.doc?.doc_speciality || '');
  const doctorDegree = (selectedDoctor?.doc?.doc_degree || '').trim();
  
  const presFormattedAge = formatAgeFromParts(
    formData.opd_guardien_years,
    formData.opd_guardien_months,
    formData.opd_guardien_days
  );
  const presAgeDisplay = presFormattedAge || (formData.opd_guardien_age ? String(formData.opd_guardien_age).trim() : 'N/A');
  
  const prescriptionData = {
    config: {
      headerLogoUrl: headerLogo,
      footer_logo: footerImage,   // <-- add this
    },
    patient: {
      uhid: formData.opd_uhid || 'N/A',
      name: `${formData.opd_patient_title || ''} ${formData.opd_patient_name || ''}`.trim(),
      address: formData.opd_address || 'N/A',
      age: presAgeDisplay,
      sex: formData.opd_patient_gender || 'N/A',
      mobile: formData.opd_patient_mobile || 'N/A',
      guardianName: formData.opd_guardien_name || '',
    },
    bill: {
      opdNo: `000${formData.opd_id}`,
      date: formattedDateTime,  // ✅ Using formatted datetime
    },
    doctor: {
      name: doctorName,
      degree: doctorDegree,
      speciality: doctorSpeciality,
      regNo: (selectedDoctor?.doc?.doc_reg_number || selectedDoctor?.doc?.doc_reg_no || '') || 'N/A',
      phone: (selectedDoctor?.doc?.doc_phone || selectedDoctor?.doc?.doc_mobile || selectedDoctor?.phone || selectedDoctor?.user_phone || '') || ''
    }
  };

  generatePrescriptionPdf(prescriptionData, type);
};

const handlePrintSelectNew = (type) => {
  setPrintType(type);
  setShowPopup(false);
 
  if (docType === 'receipt') {
    // ✅ CHECK: Does a custom format exist for this speciality?
    if (customOpdFormat && customOpdFormat.format_image) {
      generateCustomFormatPdf(type);
    } else {
      handlePrint(type);   // default receipt
    }
  } else {
    // ✅ For prescription, also check custom format
    if (customOpdFormat && customOpdFormat.format_image) {
      generateCustomFormatPdf(type);
    } else {
      generatePrescriptionPdf(type);
    }
  }
};
 
 
// ─────────────────────────────────────────────────────
// STEP 5: The custom format PDF generator
//         This reads the saved variables + positions
//         and overlays patient data on the template image
// ─────────────────────────────────────────────────────
 
const generateCustomFormatPdf = async (printType) => {
  if (!customOpdFormat) {
    toast.error('No custom format available');
    handlePrint(printType); // fallback
    return;
  }
 
  const doc = new jsPDF(
    customOpdFormat.format_orientation === 'landscape' ? 'l' : 'p',
    'pt',
    customOpdFormat.format_page_size || 'a4'
  );
 
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
 
  // ── Load template image ──
  const templateImgUrl = AppConst.BASE_URL + '/' + customOpdFormat.format_image;
  const templateBase64 = await imageUrlToBase64(templateImgUrl);
 
  if (templateBase64) {
    // Add template image as full-page background
    doc.addImage(templateBase64, 'PNG', 0, 0, pageWidth, pageHeight);
  } else {
    console.warn('Could not load template image, printing text only');
  }
 
  // ── Parse saved variables ──
  let savedVars = [];
  try {
    savedVars = JSON.parse(customOpdFormat.format_variables || '[]');
  } catch {
    savedVars = [];
  }
 
  // ── Build the data map (variable key → actual value) ──
  const selectedDoctor = formData.docs.find(d => d.user_id === formData.opd_concult_doctor) || null;
  const doctorName = selectedDoctor 
    ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''}`.trim() 
    : 'N/A';
  const docMeta = selectedDoctor?.doc || {};
  const doctorSpeciality = getSpecialityName(docMeta?.doc_specality || docMeta?.doc_speciality || '');
  const doctorDegree = (docMeta?.doc_degree || '').trim();
  const doctorRegNo = (docMeta?.doc_reg_number || docMeta?.doc_reg_no || '').toString();
 
  const actualDateTime = formData.opd_datetime || new Date().toISOString();
  const formattedDateTime = formatDateTimeForReceipt(actualDateTime);
 
  const formattedAge = formatAgeFromParts(
    formData.opd_guardien_years ?? ageYears,
    formData.opd_guardien_months ?? ageMonths,
    formData.opd_guardien_days ?? ageDays
  );
  const ageDisplay = formattedAge || (formData.opd_guardien_age ? String(formData.opd_guardien_age).trim() : 'N/A');
 
  const dataMap = {
    patient_name:       `${formData.opd_patient_title || ''} ${formData.opd_patient_name || ''}`.trim(),
    patient_uhid:       formData.opd_uhid || 'N/A',
    patient_age:        ageDisplay,
    patient_gender:     formData.opd_patient_gender || 'N/A',
    patient_mobile:     formData.opd_patient_mobile || 'N/A',
    patient_address:    formData.opd_address || '',
    guardian_name:      `${formData.opd_guardien_title || ''} ${formData.opd_guardien_name || ''}`.trim(),
    doctor_name:        doctorName,
    doctor_degree:      doctorDegree,
    doctor_speciality:  doctorSpeciality,
    doctor_reg_no:      doctorRegNo || 'N/A',
    opd_date:           formattedDateTime,
    token_no:           formData.opd_token_no || '',
    opd_id:             formData.opd_id ? `000${formData.opd_id}` : 'N/A',
    opd_fees:           parseFloat(formData.opd_fees || 0).toFixed(2),
    reg_fees:           parseFloat(formData.opd_reg_fees || 0).toFixed(2),
    total_amount:       parseFloat(formData.opd_total || 0).toFixed(2),
    discount:           parseFloat(formData.opd_discount || 0).toFixed(0),
    discount_amt:       parseFloat(formData.opd_discount_amt || 0).toFixed(2),
    final_amount:       parseFloat(formData.opd_final_amt || 0).toFixed(2),
    paid:               parseFloat(formData.opd_paid || 0).toFixed(2),
    due:                parseFloat(formData.opd_due || 0).toFixed(2),
    payment_mode:       formData.opd_mode || '',
    remark:             formData.opd_remark || '',
    amount_in_words:    numberToWords(formData.opd_final_amt || 0) + ' Only',
  };
 
  // ── Render each variable at its saved position ──
  savedVars.forEach(v => {
    const value = dataMap[v.key] || '';
    if (!value) return; // skip empty
 
    // Convert percentage positions to pt
    const xPt = (v.x / 100) * pageWidth;
    const yPt = (v.y / 100) * pageHeight;
 
    // Set font properties
    const fontSize = v.fontSize || 12;
    const fontWeight = v.fontWeight === 'bold' ? 'bold' : 'normal';
    const fontColor = v.fontColor || '#000000';
 
    // Parse hex color to RGB
    const hexToRgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) }
        : { r: 0, g: 0, b: 0 };
    };
    const rgb = hexToRgb(fontColor);
 
    doc.setFontSize(fontSize);
    doc.setFont('helvetica', fontWeight);
    doc.setTextColor(rgb.r, rgb.g, rgb.b);
    doc.text(String(value), xPt, yPt);
  });
 
  // ── If NO variables were saved, print default patient details ──
  if (savedVars.length === 0) {
    console.log('No variables defined in format — printing default layout on template');
 
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
 
    let y = 120; // start below typical header area
    const leftX = 50;
    const rightX = pageWidth / 2 + 20;
 
    const printLine = (label, value, x, yPos) => {
      doc.setFont('helvetica', 'bold');
      doc.text(`${label}:`, x, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(` ${value || ''}`, x + doc.getTextWidth(`${label}: `), yPos);
    };
 
    // Left column
    printLine('UHID', dataMap.patient_uhid, leftX, y);
    printLine('Patient Name', dataMap.patient_name, leftX, y += 15);
    printLine('Guardian', dataMap.guardian_name, leftX, y += 15);
    printLine('Address', dataMap.patient_address, leftX, y += 15);
    printLine('Payment', dataMap.payment_mode, leftX, y += 15);
 
    // Right column
    y = 120;
    printLine('Date', dataMap.opd_date, rightX, y);
    printLine('Age / Sex', `${dataMap.patient_age} / ${dataMap.patient_gender}`, rightX, y += 15);
    printLine('Token', dataMap.token_no, rightX, y += 15);
    printLine('OPD No', dataMap.opd_id, rightX, y += 15);
    printLine('Mobile', dataMap.patient_mobile, rightX, y += 15);
 
    // Doctor info
    y += 25;
    printLine('Doctor', `${dataMap.doctor_name} (${dataMap.doctor_degree})`, leftX, y);
    printLine('Speciality', dataMap.doctor_speciality, rightX, y);
 
    // Amount summary
    y += 30;
    printLine('Total', `₹${dataMap.total_amount}`, rightX, y);
    printLine('Discount', `${dataMap.discount}% / ₹${dataMap.discount_amt}`, rightX, y += 15);
    printLine('Final', `₹${dataMap.final_amount}`, rightX, y += 15);
    printLine('Paid', `₹${dataMap.paid}`, rightX, y += 15);
    printLine('Due', `₹${dataMap.due}`, rightX, y += 15);
 
    y += 20;
    doc.text(`Amount in words: ${dataMap.amount_in_words}`, leftX, y);
  }
 
  // ── Open PDF ──
  const pdfBlobUrl = doc.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};

const generateCustomPrescriptionPdf = async (printType) => {
  if (!customOpdFormat) {
    // Fallback to default prescription
    generatePrescriptionPdf(printType);
    return;
  }
 
  const pdf = new jsPDF(
    customOpdFormat.format_orientation === 'landscape' ? 'l' : 'p',
    'pt',
    customOpdFormat.format_page_size || 'a4'
  );
 
  const pageWidth  = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
 
  // ── Add template image as background (only if "With Header") ──
  if (printType === 'header') {
    const templateUrl = AppConst.BASE_URL + '/' + customOpdFormat.format_image;
    const templateBase64 = await imageUrlToBase64(templateUrl);
    if (templateBase64) {
      pdf.addImage(templateBase64, 'PNG', 0, 0, pageWidth, pageHeight);
    }
  }
 
  // ── Parse saved variable positions ──
  let savedVars = [];
  try {
    savedVars = JSON.parse(customOpdFormat.format_variables || '[]');
  } catch { savedVars = []; }
 
  // ── Build prescription data map (patient + doctor only, NO payment) ──
  const selectedDoctor = formData.docs.find(d => d.user_id === formData.opd_concult_doctor) || null;
  const doctorName = selectedDoctor
    ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''}`.trim()
    : 'N/A';
  const docMeta = selectedDoctor?.doc || {};
  const doctorSpeciality = getSpecialityName(docMeta?.doc_specality || docMeta?.doc_speciality || '');
  const doctorDegree   = (docMeta?.doc_degree || '').trim();
  const doctorRegNo    = (docMeta?.doc_reg_number || docMeta?.doc_reg_no || '').toString() || 'N/A';
  const doctorPhone    = (docMeta?.doc_phone || docMeta?.doc_mobile || selectedDoctor?.phone || selectedDoctor?.user_phone || '') || '';
 
  const actualDateTime    = formData.opd_datetime || new Date().toISOString();
  const formattedDateTime = formatDateTimeForReceipt(actualDateTime);
 
  const formattedAge = formatAgeFromParts(
    formData.opd_guardien_years ?? ageYears,
    formData.opd_guardien_months ?? ageMonths,
    formData.opd_guardien_days ?? ageDays
  );
  const ageDisplay = formattedAge || (formData.opd_guardien_age ? String(formData.opd_guardien_age).trim() : 'N/A');
 
  const dataMap = {
    patient_name:       `${formData.opd_patient_title || ''} ${formData.opd_patient_name || ''}`.trim(),
    patient_uhid:       formData.opd_uhid || 'N/A',
    patient_age:        ageDisplay,
    patient_gender:     formData.opd_patient_gender || 'N/A',
    patient_mobile:     formData.opd_patient_mobile || 'N/A',
    patient_address:    formData.opd_address || '',
    guardian_name:      `${formData.opd_guardien_title || ''} ${formData.opd_guardien_name || ''}`.trim(),
    doctor_name:        doctorName,
    doctor_degree:      doctorDegree,
    doctor_speciality:  doctorSpeciality,
    doctor_reg_no:      doctorRegNo,
    doctor_phone:       doctorPhone,
    opd_date:           formattedDateTime,
    token_no:           formData.opd_token_no || '',
    opd_id:             formData.opd_id ? `000${formData.opd_id}` : 'N/A',
  };
 
 
  // ════════════════════════════════════════════════════════════════
  //  IF variables are defined → print at saved positions
  // ════════════════════════════════════════════════════════════════
  if (savedVars.length > 0) {
    const hexToRgb = (hex) => {
      const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return r ? { r: parseInt(r[1],16), g: parseInt(r[2],16), b: parseInt(r[3],16) } : { r:0, g:0, b:0 };
    };
 
    savedVars.forEach(v => {
      const value = dataMap[v.key] || '';
      if (!value) return;
 
      const xPt = (v.x / 100) * pageWidth;
      const yPt = (v.y / 100) * pageHeight;
      const rgb = hexToRgb(v.fontColor || '#000000');
 
      pdf.setFontSize(v.fontSize || 12);
      pdf.setFont('helvetica', v.fontWeight === 'bold' ? 'bold' : 'normal');
      pdf.setTextColor(rgb.r, rgb.g, rgb.b);
      pdf.text(String(value), xPt, yPt);
    });
 
  } else {
    // ════════════════════════════════════════════════════════════════
    //  NO variables defined → default prescription layout
    //  Same structure as generatePrescriptionPdf()
    // ════════════════════════════════════════════════════════════════
 
    const margin = 40;
 
    // ── Heading Box ──
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'bold');
    //pdf.setDrawColor(0);
    //pdf.setTextColor(0, 0, 0);
    //pdf.setLineWidth(1.5);
    //pdf.rect(margin, 90, pageWidth - (margin * 2), 25);
    //pdf.text("OPD PRESCRIPTION", pageWidth / 2, 107, { align: 'center' });
 
    // ── Patient & Visit Details ──
    let y = 135;
    const rowH = 18;
    const labelW = 65;
 
    const printDetail = (label, value, x, yPos) => {
      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text(label, x, yPos);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`:  ${value || ''}`, x + labelW, yPos);
    };
 
    const col1X = margin + 5;
    const col2X = margin + 220;
    const col3X = margin + 380;
 
    printDetail("UHID No",  dataMap.patient_uhid, col1X, y);
    printDetail("OPD No",   dataMap.opd_id,       col2X, y);
    printDetail("Date",     dataMap.opd_date,      col3X, y);
    y += rowH;
 
    printDetail("Name",     dataMap.patient_name,    col1X, y);
    printDetail("Age",      dataMap.patient_age,     col2X, y);
    printDetail("Sex",      dataMap.patient_gender,  col3X, y);
    y += rowH;
 
    printDetail("Guardian", dataMap.guardian_name,    col1X, y);
    printDetail("Mobile No",dataMap.patient_mobile,  col2X, y);
    y += rowH;
 
    // Doctor row
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'bold');
    pdf.text("Doctor", col1X, y);
    pdf.setFont('helvetica', 'normal');
    const doctorStr = `:  ${dataMap.doctor_name} (${dataMap.doctor_degree}) (${dataMap.doctor_speciality})`;
    const doctorLines = pdf.splitTextToSize(doctorStr, 600);
    pdf.text(doctorLines, col1X + labelW, y);
    printDetail("Doctor Reg No", dataMap.doctor_reg_no, col3X, y);
 
    y += rowH;
    pdf.setLineWidth(0.8);
    //pdf.line(0, y, pageWidth, y);
 
    // ── Main Content Area ──
    let contentStartY = y + 30;
    const leftSectionWidth = 150;
 
    // Vertical divider
    pdf.setLineWidth(1.5);
    //pdf.line(leftSectionWidth, y, leftSectionWidth, pageHeight - margin - 20);
 
    // Section horizontal dividers
    const historyY = contentStartY + 120;
    const adviceY  = historyY + 260;
    // pdf.setLineWidth(0.5);
    // pdf.line(margin, historyY, leftSectionWidth, historyY);
    // pdf.line(margin, adviceY,  leftSectionWidth, adviceY);
 
    // Section titles
    // pdf.setFontSize(9);
    // pdf.setFont('helvetica', 'bold');
    // pdf.text("VITALS :",     margin + 5, contentStartY + 1);
    // pdf.text("Complaint :",  margin + 5, historyY + 15);
    // pdf.text("Instruction :",margin + 5, adviceY + 15);
 
    // Rx symbol
    pdf.setFontSize(22);
    pdf.setFont('times', 'bold');
    //pdf.text("Rx", leftSectionWidth + 15, contentStartY + 5);
 
    // ── Fill Vitals ──
    const leftColX = margin + 5;
    const leftColW = leftSectionWidth - 10;
    const itemFS   = 8;
    pdf.setFontSize(itemFS);
    pdf.setFont('helvetica', 'normal');
 
    let vitalsY = contentStartY + 15;
    if (formData.tests1 && formData.tests1.length > 0) {
      formData.tests1.forEach((item, idx) => {
        const vName = document.getElementById(`vital45${idx}`)?.selectedOptions[0]?.text || '';
        const vVal  = document.getElementById(`vitalval45${idx}`)?.value || '';
        if (!vName && !vVal) return;
        const text = `${idx + 1}. ${vName} ${vVal}`;
        const wrapped = pdf.splitTextToSize(text, leftColW);
        if (vitalsY + (wrapped.length * (itemFS + 2)) < historyY) {
          pdf.text(wrapped, leftColX, vitalsY);
          vitalsY += wrapped.length * (itemFS + 2);
        }
      });
    }
 
    // ── Fill Complaints ──
    let complaintsY = historyY + 30;
    if (formData.comps && formData.comps.length > 0) {
      formData.comps.forEach((item, idx) => {
        const compText = document.getElementById(`comp_txt${idx}`)?.value || '';
        if (!compText) return;
        const text = `${idx + 1}. ${compText}`;
        const wrapped = pdf.splitTextToSize(text, leftColW);
        if (complaintsY + (wrapped.length * (itemFS + 2)) < adviceY) {
          pdf.text(wrapped, leftColX, complaintsY);
          complaintsY += wrapped.length * (itemFS + 2);
        }
      });
    }
 
    // ── Fill Instructions ──
    let instructionsY = adviceY + 30;
    if (formData.inspections && formData.inspections.length > 0) {
      formData.inspections.forEach((item, idx) => {
        const inspText = document.getElementById(`insp_txt${idx}`)?.value || '';
        if (!inspText) return;
        const text = `${idx + 1}. ${inspText}`;
        const wrapped = pdf.splitTextToSize(text, leftColW);
        pdf.text(wrapped, leftColX, instructionsY);
        instructionsY += wrapped.length * (itemFS + 2);
      });
    }
  }
 
  // ── Open PDF ──
  const pdfBlobUrl = pdf.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};

// Payment Details shows only when at least one fee exists
const feesAvailable =
  (parseFloat(formData.opd_reg_fees) || 0) > 0 ||
  (parseFloat(formData.opd_fees) || 0) > 0;

  const isNewSchema = hasCityCol && hasStateCol;

  const openProcedureModal = () => {
    if (!formData.opd_id) { toast.error('Save the OPD first'); return; }
    setProcedurePatientData({
      opd_id: formData.opd_id,
      ipd_bill_uhid: formData.opd_uhid,
      ipd_no: formData.opd_id,
      ipd_bill_patient_name: formData.opd_patient_name,
      opd_uhid: formData.opd_uhid,
      opd_patient_name: formData.opd_patient_name,
      opd_patient_title: formData.opd_patient_title,
    });
    setShowActionModal(false);
    setShowProcedureModal(true);
  };
  
  const openLabModal = () => {
    if (!formData.opd_id) { toast.error('Save the OPD first'); return; }
    const selectedDoc = formData.docs.find(d => String(d.user_id) === String(formData.opd_concult_doctor)) || null;
    const doctorName = selectedDoc ? `${selectedDoc.fname || ''} ${selectedDoc.lname || ''}`.trim() : '';
  
    const labPayload = {
      lab_reg_uhid: formData.opd_uhid || '', lab_reg_id: '',
      lab_reg_name_title: formData.opd_patient_title || 'Mr.',
      lab_reg_name: formData.opd_patient_name || '',
      lab_reg_gender: formData.opd_patient_gender || 'Male',
      lab_reg_address: formData.opd_address || '', lab_reg_city: formData.opd_city || '',
      lab_reg_mobile: formData.opd_patient_mobile || '',
      lab_reg_age_year: ageYears || '0', lab_reg_age_month: ageMonths || '0', lab_reg_age_day: ageDays || '0',
      lab_guardian_title: formData.opd_guardien_title || 'C/O',
      lab_guardian_name: formData.opd_guardien_name || '',
      lab_reg_referral: doctorName, lab_reg_referral_id: formData.opd_concult_doctor || '',
      lab_reg_type: 'OPD', lab_reg_date: (formData.opd_datetime || '').split(' ')[0] || '',
      lab_collected_at: '', lab_total: '0', lab_dis_per: '0', lab_fix_deposit: '0',
      lab_final_amt: '0', lab_paid: '0', lab_due: '0', lab_pay_mode: 'Cash',
      lab_remarks: `Referred from OPD - Reg No: ${formData.opd_id || ''}`,
      tests1: [], params: [], all_tests: [],
      is_prefilled: true, source_type: 'opd', source_id: formData.opd_id || '',
    };
    try { sessionStorage.setItem('lab_prefill', JSON.stringify(labPayload)); }
    catch (e) { toast.error('Failed to prepare lab registration'); return; }
  
    setShowActionModal(false);
    setShowLabModal(true);   // 👈 opens component in a modal, no navigation
  };
  
  const openEmergencyModal = () => {
    if (!formData.opd_id) { toast.error('Save the OPD first'); return; }
    const emergencyPayload = {
      ipd_id: '', ipd_uhid: formData.opd_uhid || '',
      ipd_patient_title: formData.opd_patient_title || 'Mr.',
      ipd_patient_name: formData.opd_patient_name || '',
      ipd_patient_gender: formData.opd_patient_gender || 'Male',
      ipd_patient_mobile: formData.opd_patient_mobile || '',
      ipd_guardien_title: formData.opd_guardien_title || 'C/O',
      ipd_guardien_name: formData.opd_guardien_name || '',
      ipd_address: formData.opd_address || '', ipd_city: formData.opd_city || '',
      ipd_age_year: ageYears || '', ipd_age_month: ageMonths || '', ipd_age_day: ageDays || '',
      ipd_specality: formData.opd_specality || '',
      ipd_refer_doctor: formData.opd_concult_doctor || '',
      ipd_type: 'New Visit',
      ipd_remarks: `Referred from OPD - Reg No: ${formData.opd_id || ''}`,
    };
    try { sessionStorage.setItem('emergency_dt', JSON.stringify(emergencyPayload)); }
    catch (e) { toast.error('Failed'); return; }
  
    setShowActionModal(false);
    setShowEmergencyModal(true);   // 👈 opens component in a modal, no navigation
  };


const clearForm = () => {
  setFormData(prev => ({
    ...prev,
    tests1: [{ sn: 1, opd_val_name: '', opd_val_value: '' }],
    comps: [{ sn: 1, comp_name: '' }],
    inspections: [{ sn: 1, insp_name: '' }],
    opd_token_no: '', opd_id: '', opd_uhid: '',
    opd_patient_title: 'Mr.', opd_patient_name: '', opd_patient_gender: 'Male',
    opd_patient_mobile: '', opd_guardien_age: '',
    opd_guardien_title: 'C/O', opd_guardien_name: '',
    opd_address: '', opd_city: '',opd_state: '', opd_type: 'New Visit',
    opd_specality: '', opd_concult_doctor: '',
    opd_total: '0', opd_fees: '0',      // keep opd_reg_fees (from config)
    opd_discount: '0', opd_discount_amt: '0', opd_final_amt: '0',
    opd_paid: '0', opd_mode: '', opd_remark: '', opd_due: '0',
    opd_broker_id: '', opd_broker_name: '',
    opd_broker_commission: '0', opd_broker_commission_type: 'fixed',
  }));
  setAgeYears(''); setAgeMonths(''); setAgeDays('');
  setSelectedBroker(null); setSelectedSlot(null); setDoctorSlots([]);
  setPaymentHistory([]); setOpdSearchInput(''); setUhidSuggestions([]);
  setIsSaved(false); setOriginalRecord(null);
  setShowActionModal(false); setLastSavedPaid(''); setLastSavedDue('');

  const d = new Date();
  const dateOnly = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const full = `${dateOnly} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}:${String(d.getSeconds()).padStart(2,'0')}`;
  setFormData(prev => ({ ...prev, opd_datetime: full, opd_datetime_display: dateOnly }));
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const handleMoveToIpd = async () => {
  if (!formData.opd_id) { toast.error('Save the OPD first'); return; }
  const c = await Swal.fire({
    title: `Move ${formData.opd_patient_name || ''} to IPD?`,
    icon: 'warning', showCancelButton: true, confirmButtonText: 'Yes, Move'
  });
  if (!c.isConfirmed) return;

  setMovingToIpd(true);
  const fd = new FormData();
  fd.append('opd_id', formData.opd_id);
  fd.append('ipd_uhid', formData.opd_uhid ?? '');
  fd.append('ipd_patient_title', formData.opd_patient_title ?? '');
  fd.append('ipd_patient_name', formData.opd_patient_name ?? '');
  fd.append('ipd_patient_gender', formData.opd_patient_gender ?? '');
  fd.append('ipd_patient_mobile', formData.opd_patient_mobile ?? '');
  fd.append('ipd_guardien_title', formData.opd_guardien_title ?? '');
  fd.append('ipd_guardien_name', formData.opd_guardien_name ?? '');
  fd.append('ipd_age_year', ageYears ?? '0');
  fd.append('ipd_age_month', ageMonths ?? '0');
  fd.append('ipd_age_day', ageDays ?? '0');
  fd.append('ipd_address', formData.opd_address ?? '');
  fd.append('ipd_city', formData.opd_city ?? '');
  fd.append('ipd_specality', formData.opd_specality ?? '');
  fd.append('ipd_type', 'OPD');
  fd.append('ipd_remarks', 'Moved from OPD');
  fd.append('ipd_refer_doctor', formData.opd_concult_doctor ?? '');
  attachUserInfo(fd);

  try {
    const res = await axios.post(AppConst.BASE_URL + AppConst.addIpdUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } });
    if (res?.data?.status) {
      toast.success('✓ Patient moved to IPD');
      setShowActionModal(false);
    } else {
      toast.error(res?.data?.message || 'Failed to move to IPD');
    }
  } catch (err) {
    console.error('moveToIpd error', err);
    toast.error('Server error while moving to IPD');
  } finally {
    setMovingToIpd(false);
  }
};

    return (
      <div class="page-content">
      <style>{`
        /* When any modal is open, hide the OPD form's react-select portals + referral controls
           so they don't bleed over the modal */
        body:has(.modal.show) div[class*="-menu-portal"] { display: none !important; }
        body:has(.modal.show) .opd-reg-form .opd-referral-block { visibility: hidden !important; }
      `}</style>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xxl-12">
              <h2 style={{ color: "#405189" }}>OPD Registration</h2>
              <br />
              <div class="live-preview">
              <form className="opd-reg-form" onSubmit={handleSubmit}>
                <div className="card">
    <div className="card-body">
        <div className="row">
            <div className="col-lg-12">
                <h5 style={{color:"#405189"}}>Patient Details</h5>
                <br />
            </div>

            {/* ── ROW 1: OPD Type + Search + Patient Name + Gender ── ALL IN ONE ROW */}

            {/* OPD Type */}
 {/* OPD Type */}
<div className="col-md-2">
    <div className="mb-3">
        <label className="form-label">OPD Type</label>
        <select className="form-control" name="opd_type"
            onChange={handleChange} value={formData.opd_type} required>
            <option value="New Visit">New Visit</option>
            <option value="Old">Old</option>
        </select>
        <input type="hidden" name="opd_token_no" value={formData.opd_token_no}/>
    </div>
</div>

{/* Search — same row, only when Old */}
{/* Search — unified smart search (auto-detects UHID / Phone / Name) */}
{formData.opd_type === 'Old' && (
    <div className="col-md-4">
        <div className="mb-3" style={{position:'relative'}}>
            <label className="form-label">
                Search Patient
                <small className="text-muted ms-2" style={{fontSize:11, fontWeight:400}}>
                    (UHID / Phone / Name)
                </small>
            </label>

            <div className="input-group">
                <span className="input-group-text" style={{background:'#f8f9fa'}}>
                    <i className="ri-search-line text-primary"/>
                </span>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Type UHID, 10-digit phone, or patient name..."
                    value={opdSearchInput}
                    onChange={e => handleUnifiedSearch(e.target.value)}
                    autoComplete="off"
                />
                {opdSearchLoading && (
                    <span className="input-group-text" style={{background:'#fff'}}>
                        <span className="spinner-border spinner-border-sm text-primary"/>
                    </span>
                )}
                {opdSearchInput && (
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => { setOpdSearchInput(''); setUhidSuggestions([]); }}
                        title="Clear">
                        <i className="ri-close-line"/>
                    </button>
                )}
            </div>

            <small className="text-muted" style={{fontSize:10}}>
                💡 Phone (10 digits) searches instantly. UHID/Name needs 3+ characters.
            </small>

            {/* Unified suggestions dropdown */}
            {uhidSuggestions.length > 0 && (
                <ul style={{
                    position:'absolute',
                    top:'100%',
                    left:0,
                    right:0,
                    zIndex:1050,
                    maxHeight:280,
                    overflowY:'auto',
                    border:'1px solid #dee2e6',
                    borderRadius:4,
                    boxShadow:'0 4px 12px rgba(0,0,0,0.15)',
                    margin:'4px 0 0 0',
                    padding:0,
                    listStyle:'none',
                    background:'#fff'
                }}>
                    <li style={{
                        padding:'6px 12px',
                        background:'#f8f9fa',
                        borderBottom:'1px solid #dee2e6',
                        fontSize:11,
                        color:'#405189',
                        fontWeight:600
                    }}>
                        {uhidSuggestions.length} match{uhidSuggestions.length !== 1 ? 'es' : ''} found — click to select
                    </li>
                    {uhidSuggestions.map((user, idx) => (
                        <li key={idx}
                            onClick={() => {
                                applyOpdPatient(user);
                                setOpdSearchInput('');
                            }}
                            style={{
                                cursor:'pointer',
                                fontSize:12,
                                padding:'10px 12px',
                                borderBottom:'1px solid #f0f0f0',
                                transition:'background .1s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                            onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div style={{flex:1}}>
                                    <div>
                                        <strong style={{color:'#405189'}}>{user.lab_reg_name_title} {user.lab_reg_name}</strong>
                                    </div>
                                    <div className="text-muted mt-1" style={{fontSize:11}}>
                                        <span className="me-2">
                                            <i className="ri-fingerprint-line me-1"/>
                                            <strong>{user.lab_reg_uhid}</strong>
                                        </span>
                                        <span className="me-2">
                                            <i className="ri-phone-line me-1"/>
                                            {user.lab_reg_mobile}
                                        </span>
                                        <span className="me-2">
                                            {user.lab_reg_age_year ? user.lab_reg_age_year+'Y' : ''} / {user.lab_reg_gender}
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex gap-1 ms-2 flex-shrink-0 flex-wrap" style={{maxWidth:120}}>
                                    {(user.lab_visit_count > 0) && (
                                        <span className="badge" style={{background:'#cff4fc',color:'#055160',fontSize:9}}>
                                            🧪{user.lab_visit_count}x
                                        </span>
                                    )}
                                    {(user.ipd_visit_count > 0) && (
                                        <span className="badge" style={{background:'#cfe2ff',color:'#084298',fontSize:9}}>
                                            🏥{user.ipd_visit_count}x
                                        </span>
                                    )}
                                    {(user.opd_visit_count > 0) && (
                                        <span className="badge" style={{background:'#d1e7dd',color:'#0f5132',fontSize:9}}>
                                            🩺{user.opd_visit_count}x
                                        </span>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}

        </div>
    </div>
)}

{/* Patient Name */}
<div className={formData.opd_type === 'Old' ? 'col-md-4' : 'col-md-6'}>
    <div className="mb-3">
        <label className="form-label">Patient Name</label>
        <div className="row g-1">
            <div className="col-md-4">
                <select className="form-control" name="opd_patient_title"
                    onChange={handleChange} value={formData.opd_patient_title} required>
                    <option value="Mr.">Mr.</option>
                    <option value="Mr's">Mr's</option>
                    <option value="Miss">Miss</option>
                    <option value="Master">Master</option>
                    <option value="Baby">Baby</option>
                    <option value="B/O">B/O</option>
                </select>
            </div>
            <div className="col-md-8">
                <input type="text" className="form-control"
                    placeholder="Enter Name"
                    name="opd_patient_name"
                    onChange={handleChange}
                    value={formData.opd_patient_name} required/>
            </div>
        </div>
    </div>
</div>




{/* Gender */}
<div className="col-md-2">
    <div className="mb-3">
        <label className="form-label">Gender</label>
        {(formData.opd_patient_title === 'Baby' || formData.opd_patient_title === 'B/O') ? (
            <select
                className="form-control"
                name="opd_patient_gender"
                onChange={handleChange}
                value={formData.opd_patient_gender}
                required
            >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
            </select>
        ) : (
            <input
                className="form-control"
                name="opd_patient_gender"
                onChange={handleChange}
                value={formData.opd_patient_gender}
                required
                readOnly
                style={{ background: "#eeeeee" }}
            />
        )}
    </div>
</div>




            {/* ── ROW 2: Age + Guardian + Speciality + Doctor ── */}
            <div className="col-md-3">
                <div className="mb-3">
                    <label className="form-label">Age</label>
                    <div className="d-flex gap-1">
                        <input type="number" min="0" className="form-control"
                            placeholder="Y" value={ageYears}
                            onChange={e => setAgeYears(e.target.value === '' ? '' : String(Math.max(0, Number(e.target.value))))}
                            required/>
                        <input type="number" min="0" max="11" className="form-control"
                            placeholder="M" value={ageMonths}
                            onChange={e => setAgeMonths(e.target.value === '' ? '' : String(Math.max(0, Math.min(11, Number(e.target.value)))))}/>
                        <input type="number" min="0" max="31" className="form-control"
                            placeholder="D" value={ageDays}
                            onChange={e => setAgeDays(e.target.value === '' ? '' : String(Math.max(0, Math.min(31, Number(e.target.value)))))}/>
                    </div>
                    <small className="text-muted" style={{fontSize:11}}>
                        {(ageYears || ageMonths || ageDays)
                            ? `${ageYears ? ageYears+'Y ' : ''}${ageMonths ? ageMonths+'M ' : ''}${ageDays ? ageDays+'D' : ''}`.trim()
                            : '0Y'}
                    </small>
                </div>
            </div>

            <div className="col-md-3">
                <div className="mb-3">
                    <label className="form-label">Guardian</label>
                    <div className="row">
                        <div className="col-md-4">
                            <select className="form-control" name="opd_guardien_title"
                                onChange={handleChange} value={formData.opd_guardien_title} required>
                                <option value="C/O">C/O</option>
                                <option value="S/O">S/O</option>
                                <option value="D/O">D/O</option>
                            </select>
                        </div>
                        <div className="col-md-8">
                            <input type="text" className="form-control"
                                placeholder="Enter Name" name="opd_guardien_name"
                                onChange={handleChange} value={formData.opd_guardien_name} required/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-3 opd-referral-block" style={{position:'relative', zIndex: 1100}}>
                <div className="mb-3">
                    <label className="form-label">Speciality</label>
                    <Select
    options={specialityOptions}
    value={specialityOptions.find(o => String(o.value) === String(formData.opd_specality)) || null}
    onChange={handleSpecSelect}
    placeholder="Select speciality..."
    isClearable
    menuPortalTarget={document.body}
    menuPosition="fixed"
    styles={{menuPortal: b => ({...b, zIndex:100000})}}
/>
                </div>

                {formatLoading && (
    <small className="text-muted">
      <span className="spinner-border spinner-border-sm me-1"/>
      Checking format...
    </small>
  )}
  {!formatLoading && customOpdFormat && (
    <small className="text-success" style={{fontSize:11}}>
      <i className="ri-file-image-line me-1"/>
      Custom format available for this speciality
    </small>
  )}
  {!formatLoading && formData.opd_specality && !customOpdFormat && (
    <small className="text-muted" style={{fontSize:11}}>
      Default format will be used
    </small>
  )}
            </div>
           
            <div className="col-md-3 opd-referral-block" style={{position:'relative', zIndex: 1100}}>
                <div className="mb-3">
                    <label className="form-label">Consultant Doctor</label>
                    <Select
    options={doctorOptions}
    value={doctorOptions.find(o => String(o.value) === String(formData.opd_concult_doctor)) || null}
    onChange={handleDocSelect}
    placeholder="Select doctor..."
    isClearable
    menuPortalTarget={document.body}
    menuPosition="fixed"
    styles={{menuPortal: b => ({...b, zIndex:100000})}}
/>
                </div>
            </div>

            {/* ✅ Appointment Date + Slots — visible only when doctor is selected */}
{formData.opd_concult_doctor && (
  <div className="col-md-12 mb-3">
    <div className="row g-2 align-items-end">
      
      {/* Appointment Date Picker */}
      <div className="col-md-3">
        <label className="form-label fw-bold" style={{color:'#405189'}}>
          <i className="ri-calendar-line me-1"/>Appointment Date
        </label>
        <input
          type="date"
          className="form-control"
          value={slotDate}
          min={new Date().toISOString().split('T')[0]}
          onChange={(e) => setSlotDate(e.target.value)}
        />
        <small className="text-muted" style={{fontSize:11}}>
          {slotDate === new Date().toISOString().split('T')[0]
            ? 'Today'
            : `Booking for ${new Date(slotDate).toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })}`}
        </small>
      </div>

      {/* Slots Display */}
      <div className="col-md-9">
        <label className="form-label fw-bold" style={{color:'#405189'}}>
          <i className="ri-calendar-check-line me-1"/>Available Slots
          {selectedSlot && (
            <span className="badge bg-success ms-2">
              Selected: {selectedSlot.time_display} on {new Date(slotDate).toLocaleDateString('en-GB')}
            </span>
          )}
        </label>

        <div style={{
          minHeight: 46,
          padding: 8,
          border: '1px dashed #dee2e6',
          borderRadius: 6,
          background: '#fafbfe'
        }}>
          {slotsLoading ? (
            <div className="text-center py-2">
              <span className="spinner-border spinner-border-sm text-primary me-2"/>
              <span className="text-muted">Loading slots...</span>
            </div>
         ) : doctorSlots.length === 0 ? (
          <div className="text-center py-2">
            <i className="ri-calendar-close-line text-warning me-2" style={{fontSize:18}}/>
            <span className="text-warning fw-semibold">
              {slotUnavailableReason
                ? slotUnavailableReason
                : `No slots available for this doctor on ${new Date(slotDate).toLocaleDateString('en-GB')}`}
            </span>
          </div>
        ) : (
            <div className="d-flex flex-wrap gap-2">
              {doctorSlots.map((s, i) => (
                <span
                  key={i}
                  className={`badge px-3 py-2 ${
                    selectedSlot?.time === s.time ? 'bg-primary' :
                    s.status === 'booked' ? 'bg-warning text-dark' : 'bg-success'
                  }`}
                  style={{
                    cursor: s.status === 'available' ? 'pointer' : 'not-allowed',
                    fontSize: 13
                  }}
                  onClick={() => { if (s.status === 'available') setSelectedSlot(s); }}
                  title={s.status === 'booked' && s.booking ? `Booked: ${s.booking.booking_patient_name || ''}` : ''}
                >
                  {s.time_display} {s.status === 'booked' ? '(Booked)' : ''}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}

            {/* ── ROW 3: Phone + Date + Address ── */}
           {/* ── ROW 3: Phone + Date ── */}
<div className="col-md-3">
  <div className="mb-3">
    <label className="form-label">Phone No</label>
    <input type="text" className="form-control"
      placeholder="Enter Phone No"
      name="opd_patient_mobile"
      value={formData.opd_patient_mobile || ''}
      onChange={handleChange}/>
  </div>
</div>

<div className="col-md-3">
  <div className="mb-3">
    <label className="form-label">Registration Date</label>
    <input type="date" className="form-control"
      name="opd_datetime_display"
      onChange={e => {
        const dateValue = e.target.value;
        const now = new Date();
        const h = String(now.getHours()).padStart(2,'0');
        const m = String(now.getMinutes()).padStart(2,'0');
        const s = String(now.getSeconds()).padStart(2,'0');
        setFormData(prev => ({
          ...prev,
          opd_datetime: `${dateValue} ${h}:${m}:${s}`,
          opd_datetime_display: dateValue
        }));
      }}
      value={formData.opd_datetime_display || (formData.opd_datetime ? formData.opd_datetime.split(' ')[0] : '')}
      required
      readOnly={!!formData.opd_id}
      style={formData.opd_id ? { background: "#eeeeee" } : {}}
    />
  </div>
</div>


{/* ── Referral (Broker) ── */}
<div className="col-md-6 opd-referral-block" style={{position:'relative', zIndex: 1100}}>
  <div className="mb-3">
    <div className="d-flex align-items-center justify-content-between mb-1">
      <label className="form-label mb-0">
        <i className="ri-user-shared-line me-1"/>Referral
        {brokerCommission > 0 && (
          <span className="badge bg-success ms-2" style={{fontSize:11}}>
            Commission: ₹{brokerCommission.toFixed(2)}
          </span>
        )}
      </label>
      <button
        type="button"
        className="btn btn-success btn-sm"
        onClick={() => setShowBrokerModal(true)}
      >
        <i className="ri-add-line me-1"/>Add Referral
      </button>
    </div>



    <Select
  options={(brokers || []).map(b => ({
    value: b.id || b.broker_id,
    label: `${b.fname || ''} ${b.lname || ''}`.trim() +
           (b.mobile ? ` (${b.mobile})` : '') +
           (b.opd_commission
              ? ` — OPD: ${b.opd_commission_type === 'percentage' ? b.opd_commission + '%' : '₹' + b.opd_commission}`
              : '')
  }))}
  value={
    formData.opd_broker_id
      ? { value: formData.opd_broker_id, label: formData.opd_broker_name }
      : null
  }
  onChange={(option) => {
    if (!option) { setSelectedBroker(null); return; }
    const b = brokers.find(x => String(x.id || x.broker_id) === String(option.value));
    setSelectedBroker(b || null);
  }}
  placeholder="Select referral / broker..."
  isClearable
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
    menuPortal: b => ({ ...b, zIndex: 100000 }),
    container:  b => ({ ...b, width: '100%' }),
  }}
/>
    {selectedBroker && (
      <small className="text-muted" style={{fontSize:11}}>
        OPD Commission Type: <strong>{(selectedBroker.opd_commission_type || 'fixed').toUpperCase()}</strong> |
        Rate: <strong>
          {selectedBroker.opd_commission_type === 'percentage'
            ? `${selectedBroker.opd_commission || 0}%`
            : `₹${selectedBroker.opd_commission || 0}`}
        </strong>
      </small>
    )}
  </div>
</div>
{/* ── Address + City + State ── */}
<div className={`col-md-${12 - (hasCityCol ? 3 : 0) - (hasStateCol ? 3 : 0)}`}>
  <div className="mb-3">
    <label className="form-label">Address</label>
    <textarea rows={2} className="form-control"
      name="opd_address" placeholder="Enter Address"
      value={formData.opd_address || ''} onChange={handleChange}/>
  </div>
</div>

{hasCityCol && (
  <div className="col-md-3">
    <div className="mb-3">
      <label className="form-label">City</label>
      <input type="text" className="form-control"
        name="opd_city" placeholder="Enter City"
        value={formData.opd_city || ''} onChange={handleChange}/>
    </div>
  </div>
)}

{hasStateCol && (
  <div className="col-md-3">
    <div className="mb-3">
      <label className="form-label">State</label>
      <input type="text" className="form-control"
        name="opd_state" placeholder="Enter State"
        value={formData.opd_state || ''} onChange={handleChange}/>
    </div>
  </div>
)}

        </div>{/* end .row */}
    </div>{/* end .card-body */}
</div>

{/* ── OPD Patient Selection Modal ── */}
{showOpdPatientModal && (
    <div className="modal fade show d-block" tabIndex="-1"
        style={{backgroundColor:'rgba(0,0,0,0.5)', zIndex:10000}}>
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">
                        <i className="ri-group-line me-2"/>
                        Select Patient — {opdPatientResults.length} found
                    </h5>
                    <button type="button" className="btn-close btn-close-white"
                        onClick={() => setShowOpdPatientModal(false)}/>
                </div>
                <div className="modal-body p-2">
                    {opdPatientResults.map((p, idx) => {
                        const age = [
                            p.lab_reg_age_year  ? `${p.lab_reg_age_year}Y`  : '',
                            p.lab_reg_age_month ? `${p.lab_reg_age_month}M` : '',
                            p.lab_reg_age_day   ? `${p.lab_reg_age_day}D`   : '',
                        ].filter(Boolean).join(' ') || 'N/A';
                        const labV    = p.lab_visit_count    ?? 0;
                        const ipdV    = p.ipd_visit_count    ?? 0;
                        const opdV    = p.opd_visit_count    ?? 0;
                        const pharmaV = p.pharma_visit_count ?? 0;
                        return (
                            <div key={idx} className="p-3 mb-2 rounded"
                                style={{border:'1px solid #dee2e6', cursor:'pointer',
                                    background:'#fff', transition:'background .15s'}}
                                onMouseEnter={e => e.currentTarget.style.background='#f0f4ff'}
                                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                                <div className="d-flex justify-content-between align-items-start">
                                    <div style={{flex:1}}>
                                        <div className="fw-bold fs-6">
                                            {p.lab_reg_name_title} {p.lab_reg_name}
                                        </div>
                                        <div className="text-muted mt-1" style={{fontSize:12}}>
                                            <span className="me-3">
                                                <i className="ri-fingerprint-line me-1"/>
                                                UHID: <strong>{p.lab_reg_uhid}</strong>
                                            </span>
                                            <span className="me-3">{age} / {p.lab_reg_gender}</span>
                                            <span>
                                                <i className="ri-phone-line me-1"/>{p.lab_reg_mobile}
                                            </span>
                                        </div>
                                        <div className="mt-2 d-flex gap-2 flex-wrap">
                                            {labV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cff4fc',color:'#055160',fontSize:11,padding:'4px 8px'}}>
                                                    🧪 Lab: {labV}x
                                                </span>
                                            )}
                                            {ipdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#cfe2ff',color:'#084298',fontSize:11,padding:'4px 8px'}}>
                                                    🏥 IPD: {ipdV}x
                                                </span>
                                            )}
                                            {opdV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#d1e7dd',color:'#0f5132',fontSize:11,padding:'4px 8px'}}>
                                                    🩺 OPD: {opdV}x
                                                </span>
                                            )}
                                            {pharmaV > 0 && (
                                                <span className="badge"
                                                    style={{background:'#fff3cd',color:'#664d03',fontSize:11,padding:'4px 8px'}}>
                                                    💊 Pharma: {pharmaV}x
                                                </span>
                                            )}
                                            {(labV+ipdV+opdV+pharmaV) === 0 && (
                                                <span className="badge bg-secondary" style={{fontSize:11}}>
                                                    New Patient
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <button type="button"
                                        className="btn btn-sm btn-primary ms-3"
                                        onClick={() => applyOpdPatient(p)}>
                                        <i className="ri-check-line me-1"/>Select
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary"
                        onClick={() => setShowOpdPatientModal(false)}>Cancel</button>
                </div>
            </div>
        </div>
    </div>
)}






{feesAvailable && (
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <h5 style={{ color: "#405189" }}>Payment Details</h5>
                          <br />
                        </div>


                        {isNewSchema && isSaved && formData.opd_id && (
  <div className="card">
    <div className="card-body">
      <div className="row">
        <div className="col-lg-12">
          <h5 style={{ color: "#405189" }}>Payment History</h5>
          <br />
        </div>
        <div className="col-lg-12">
          {paymentHistory.length === 0 ? (
            <div className="alert alert-info">No payment transactions yet</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "60px" }}>Sl. No</th>
                    <th>Date &amp; Time</th>
                    <th>Payment Mode</th>
                    <th>Amount</th>
                    <th>Received By</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.map((p, index) => (
                    <tr key={p.payment_id || index}>
                      <td>{index + 1}</td>
                      <td>{new Date(p.payment_datetime).toLocaleString()}</td>
                      <td>
                        <span className={`badge ${
                          p.payment_mode === 'Cash' ? 'bg-success' :
                          p.payment_mode === 'Card' ? 'bg-primary' : 'bg-info'
                        }`}>
                          {p.payment_mode}
                        </span>
                      </td>
                      <td className="fw-bold">₹{parseFloat(p.payment_amount).toFixed(2)}</td>
                      <td>{p.received_by}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-light">
                  <tr>
                    <th colSpan="3" className="text-end">Total Paid:</th>
                    <th className="fw-bold">
                      ₹{paymentHistory.reduce((s, p) => s + parseFloat(p.payment_amount || 0), 0).toFixed(2)}
                    </th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Total Amount
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Total Amount"
                              name="opd_total"
                              onChange={handleChange}
                             value={formData.opd_concult_doctor ? (formData.opd_total ?? 0) : formData.opd_reg_fees}

                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              OPD Fees
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter OPD Fees"
                              name="opd_fees"
                              onChange={handleChange}
                         value={Number(formData.opd_fees) || 0}



                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Registration Fees
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Registration Fees"
                              name="opd_reg_fees"
                              onChange={handleChange}
                              value={formData.opd_reg_fees}
                              required
                              readOnly
                            />
                          </div>
                        </div>
                        <div class="col-md-2">
  <div class="mb-3">
    <label for="firstNameinput" class="form-label">
      Discount(%)
    </label>
    <input
      type="text"
      class="form-control"
      placeholder="Enter %"
      name="opd_discount"
      onChange={handleChange}
      value={formData.opd_discount}
    />
  </div>
</div>
<div class="col-md-2">
  <div class="mb-3">
    <label for="firstNameinput" class="form-label">
      Discount(₹)
    </label>
    <input
      type="text"
      class="form-control"
      placeholder="Enter Amount"
      name="opd_discount_amt"
      onChange={handleChange}
      value={formData.opd_discount_amt}
    />
  </div>
</div>
                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Final Amount
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Final Amount"
                              name="opd_final_amt"
                              onChange={handleChange}
                              value=
                              {formData.opd_concult_doctor ? (formData.opd_final_amt ?? 0) : formData.opd_reg_fees}
                              required
                              readOnly
                            />
                          </div>
                        </div>



                        <div class="col-md-4">
                          <div class="mb-3">
                            <label for="firstNameinput" class="form-label">
                              Paid
                            </label>
                           <input
  type={isNewSchema ? "text" : "number"}
  className="form-control"
  placeholder="Enter Paid"
  name="opd_paid"
  value={formData.opd_paid}
  onChange={handleChange}
  readOnly={isNewSchema}
  min="0"
  step="0.01"
  style={isNewSchema ? { backgroundColor: '#e9ecef' } : {}}
/>
                          </div>
                        </div>





                        <div className={`col-md-${isNewSchema ? 3 : 4}`}>
  <div className="mb-3">
    <label htmlFor="paymentMode" className="form-label">Payment Mode</label>
    <select
      className="form-control"
      name="opd_mode"
      onChange={handleChange}
      value={formData.opd_mode}
      disabled={isNewSchema}
      style={isNewSchema ? { backgroundColor: '#e9ecef' } : {}}
    >
      <option value="">Select Payment Mode</option>
      <option value="Cash">Cash</option>
      <option value="Online">Online</option>
      <option value="Card">Card</option>
    </select>
  </div>
</div> 

<div className={`col-md-${isNewSchema ? 6 : 4}`}>
  <div className="mb-3">
    <label className="form-label">
      Remarks
    </label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Remarks"
                              name="opd_remark"
                              onChange={handleChange}
                              value={formData.opd_remark}
                              
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
  <div class="mb-3">
  <label className="form-label">Due</label>
<div className="input-group">
  <input
    type="text"
    className="form-control"
    placeholder="Enter Due"
    name="opd_due"
    value={formData.opd_concult_doctor ? (formData.opd_due ?? 0) : formData.opd_reg_fees}
    readOnly
    style={{ backgroundColor: '#e9ecef' }}
  />
  {isNewSchema && parseFloat(formData.opd_due || 0) > 0 && (
    <button
      className="btn btn-success"
      type="button"
      onClick={() => {
        const dueAmount = parseFloat(String(formData.opd_due).replace(/[,]/g, '')) || 0;
        setPaymentAmount(dueAmount.toFixed(2));
        setPaymentMode('Cash');
        setShowPaymentModal(true);
      }}
    >
      <i className="ri-money-dollar-circle-line me-1"></i>Pay
    </button>
  )}
</div>
  </div>
</div>
                      </div>
                    </div>
                  </div>

)}


                 <div className="col-lg-12">
  <div className="card bg-light shadow-sm p-3 mb-3">
    <div className="text-end">
      <button
        type="button"
        className="btn btn-outline-primary d-inline-flex align-items-center"
        onClick={() => setShowOtherDetails(!showOtherDetails)}
      >
        {showOtherDetails ? (
          <i className="ri-arrow-up-s-line me-1 align-middle"></i>
        ) : (
          <i className="ri-arrow-down-s-line me-1 align-middle"></i>
        )}
        {showOtherDetails ? "Hide Details" : "More Details"}
      </button>
    </div>
  </div>
</div>


                 {showOtherDetails && (
                    <>
                    <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <h5 style={{ color: "#405189" }}>Other Details</h5>
                          <br />
                        </div>
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-8">
                              <h6>Vital Details</h6>
                            </div>
                            <div
                              className="col-lg-4"
                              style={{ textAlign: "right" }}
                            >
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setFormData((prev) => ({
                                    ...prev,
                                    tests1: [
                                      ...prev.tests1,
                                      {
                                        sn: prev.tests1.length + 1,
                                        opd_val_name: "",
                                        opd_val_value: "",
                                      },
                                    ],
                                  }));
                                }}
                                className="btn btn-primary"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          <br />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body pt-0">
                            <div>
                              <div className="table-responsive table-card mb-1">
                                <table
                                  className="table table-nowrap align-middle"
                                  id="orderTable"
                                >
                                  <thead className="text-muted table-light">
                                    <tr className="text-uppercase">
                                      <th data-sort="id">S. No.</th>
                                      <th data-sort="customer_name">
                                        Vital Name
                                      </th>
                                      <th data-sort="city">Value</th>
                                      <th data-sort="city">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody className="list form-check-all">
                                    {formData.tests1.map((item, index) => (
                                      <tr key={index}>
                                        <td className="customer_name">
                                          {index + 1}.
                                        </td>
                                        <td className="product_name">
                                          <select
                                            className="form-control"
                                            data-trigger=""
                                            id={"vital45" + index}
                                          >
                                            {formData.vitals.map(
                                              (vital, idx) => (
                                                <option
                                                  key={idx}
                                                  value={vital.cat_id}
                                                >
                                                  {vital.cat_name}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </td>
                                        <td className="date">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id={"vitalval45" + index}
                                          />
                                        </td>
                                        <td>
                                          <ul className="list-inline hstack gap-2 mb-0">
                                            <li className="list-inline-item">
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  const tmp = [
                                                    ...formData.tests1,
                                                  ];
                                                  tmp.splice(index, 1);
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    tests1: tmp,
                                                  }));
                                                }}
                                              >
                                                <i className="ri-delete-bin-5-fill fs-16"></i>{" "}
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

               
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-8">
                              <h5 style={{ color: "#405189" }}>Complaints</h5>
                            </div>
                            <div
                              className="col-lg-4"
                              style={{ textAlign: "right" }}
                            >
                              <button
                                type="button"
                                onClick={addComplaint}
                                className="btn btn-primary"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          <br />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body pt-0">
                            <div>
                              <div className="table-responsive table-card mb-1">
                                <table
                                  className="table table-nowrap align-middle"
                                  id="orderTable"
                                >
                                  <thead className="text-muted table-light">
                                    <tr className="text-uppercase">
                                      <th
                                        data-sort="id"
                                        style={{ width: "60px" }}
                                      >
                                        S. No.
                                      </th>
                                      <th data-sort="customer_name">
                                        Complaint Name
                                      </th>
                                      <th
                                        data-sort="city"
                                        style={{ width: "100px" }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="list form-check-all">
                                    {formData.comps.map((item, index) => (
                                      <tr key={index}>
                                        <td className="customer_name">
                                          {index + 1}.
                                        </td>
                                        <td className="date">
                                          <textarea
                                            className="form-control"
                                            id={`comp_txt${index}`}
                                            rows="3"
                                          ></textarea>
                                        </td>
                                        <td>
                                          <ul className="list-inline hstack gap-2 mb-0">
                                            <li className="list-inline-item">
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                  removeComplaint(index)
                                                }
                                              >
                                                <i className="ri-delete-bin-5-fill fs-16"></i>{" "}
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-8">
                              <h5 style={{ color: "#405189" }}>Instruction</h5>
                            </div>
                            <div
                              className="col-lg-4"
                              style={{ textAlign: "right" }}
                            >
                              <button
                                type="button"
                                onClick={addInspection}
                                className="btn btn-primary"
                              >
                                Add
                              </button>
                            </div>
                          </div>
                          <br />
                        </div>
                        <div className="col-md-12">
                          <div className="card-body pt-0">
                            <div>
                              <div className="table-responsive table-card mb-1">
                                <table
                                  className="table table-nowrap align-middle"
                                  id="orderTable"
                                >
                                  <thead className="text-muted table-light">
                                    <tr className="text-uppercase">
                                      <th
                                        data-sort="id"
                                        style={{ width: "60px" }}
                                      >
                                        S. No.
                                      </th>
                                      <th data-sort="customer_name">
                                        Instruction Name
                                      </th>
                                      <th
                                        data-sort="city"
                                        style={{ width: "100px" }}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="list form-check-all">
                                    {formData.inspections.map((item, index) => (
                                      <tr key={index}>
                                        <td className="customer_name">
                                          {index + 1}.
                                        </td>
                                        <td className="date">
                                          <textarea
                                            className="form-control"
                                            id={`insp_txt${index}`}
                                            rows="3"
                                          ></textarea>
                                        </td>
                                        <td>
                                          <ul className="list-inline hstack gap-2 mb-0">
                                            <li className="list-inline-item">
                                              <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() =>
                                                  removeInspection(index)
                                                }
                                              >
                                                <i className="ri-delete-bin-5-fill fs-16"></i>{" "}
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                  </> 
                 )}
                   <div className="card">
                          <div className="card-body">
                            <div className="row">
                              {/* Submit Buttons */}
                              <div className="col-lg-12">
                                <div className="text-end">
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                  >
                                    Save
                                  </button>
                                  &nbsp;&nbsp;&nbsp;


                                  <button
  type="button"
  className="btn btn-success"
  disabled={!isSaved || !formData.opd_uhid}
  onClick={() =>
    printThermalBarcodeIframe(
      `${formData.opd_patient_title || ""} ${formData.opd_patient_name || ""}`.trim(),
      // Use formatted age display (prefer numeric parts if present)
      (formatAgeFromParts(formData.opd_guardien_years, formData.opd_guardien_months, formData.opd_guardien_days) || formData.opd_guardien_age || 'N/A'),
      formData.opd_uhid
    )
  }
>
  Print Barcode
</button>

<canvas ref={barcodeCanvasRef} style={{ display: 'none' }} />
&nbsp;&nbsp;&nbsp;
<button type="button" className="btn btn-dark"

disabled={!isSaved || !formData.opd_uhid}
  onClick={() => { setReturnToActionModal(true); setShowActionModal(false); setDocType('receipt'); setPrintType('header'); setShowPopup(true); }}>
  <i className="ri-file-list-3-line me-1" />Print Receipt
</button>



                                  &nbsp;&nbsp;&nbsp;
                                  <button
    type="button"
    className="btn btn-info"
    onClick={() => {
      setDocType('prescription');
      setPrintType('header');
      setShowPopup(true);
    }}
    disabled={
      !isSaved ||
      !formData.opd_uhid ||
      parseFloat(formData.opd_due || 0) !== 0 ||
      parseFloat(String(formData.opd_paid || 0)) !== parseFloat(String(lastSavedPaid || 0))
    }
  >
    Print Prescription
    {customOpdFormat && (
      <span className="badge bg-warning ms-1" style={{fontSize:9}}>Custom</span>
    )}
  </button>


                                  &nbsp;&nbsp;&nbsp;
                                  <a href="/opd_patient_list" className="btn btn-danger">Cancel</a>
&nbsp;&nbsp;&nbsp;
<button type="button" className="btn btn-outline-secondary" onClick={clearForm}>
  <i className="ri-refresh-line me-1"></i>Add New
</button>

  <>
    &nbsp;&nbsp;&nbsp;
    <button type="button" className="btn btn-primary"
      disabled={!isSaved || !formData.opd_uhid}
      onClick={() => setShowActionModal(true)}>
      <i className="ri-more-2-line me-1"></i>More
    </button>
  </>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {showPopup && (
  <>
    <div className="modal fade show" style={{ display: 'block', zIndex: 10060 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Select Print Type</h5>
            <button
              className="btn-close"
              onClick={() => setShowPopup(false)}
            ></button>
          </div>

          <div className="modal-body">

            {/* ✅ RADIO BUTTONS */}
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="printType"
                value="header"
                checked={printType === 'header'}
                onChange={(e) => setPrintType(e.target.value)}
              />
              <label className="form-check-label">
                With Header
              </label>
            </div>

            <div className="form-check mt-2">
              <input
                className="form-check-input"
                type="radio"
                name="printType"
                value="noheader"
                checked={printType === 'noheader'}
                onChange={(e) => setPrintType(e.target.value)}
              />
              <label className="form-check-label">
                Without Header
              </label>
            </div>

          </div>

          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={() => handlePrintSelect(printType)}
            >
              Print
            </button>

            <button
              className="btn btn-danger"
              onClick={() => setShowPopup(false)}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>

    {/* backdrop */}
    <div className="modal-backdrop fade show"></div>
  </>
)}
{showPaymentModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 10000 }}>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add Payment</h5>
          <button type="button" className="btn-close" onClick={() => setShowPaymentModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label className="form-label">Due Amount</label>
            <input type="text" className="form-control"
              value={`₹${parseFloat(formData.opd_due || 0).toFixed(2)}`}
              readOnly style={{ backgroundColor: '#e9ecef', fontWeight: 'bold', fontSize: '1.1rem' }} />
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Mode *</label>
            <select className="form-control" value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)}>
              <option value="Cash">Cash</option>
              <option value="Card">Card</option>
              <option value="Online">Online</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Amount *</label>
            <input type="number" className="form-control" placeholder="Enter amount"
              value={paymentAmount}
              onChange={(e) => setPaymentAmount(e.target.value)}
              max={parseFloat(String(formData.opd_due).replace(/[,]/g, ''))}
              step="0.01" min="0.01" />
            <small className="text-muted">
              Maximum: ₹{parseFloat(String(formData.opd_due).replace(/[,]/g, '') || 0).toFixed(2)}
            </small>
            <div className="mt-2 d-flex gap-2">
              <button type="button" className="btn btn-sm btn-outline-primary"
                onClick={() => setPaymentAmount((parseFloat(String(formData.opd_due).replace(/[,]/g, '')) || 0).toFixed(2))}>
                Full Amount
              </button>
              <button type="button" className="btn btn-sm btn-outline-secondary"
                onClick={() => setPaymentAmount((parseFloat(String(formData.opd_due).replace(/[,]/g, '')) / 2 || 0).toFixed(2))}>
                Half Amount
              </button>
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Received By</label>
            <input type="text" className="form-control" value={paymentReceivedBy} readOnly
              style={{ backgroundColor: '#e9ecef' }} />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowPaymentModal(false)}>Cancel</button>
          <button type="button" className="btn btn-success" onClick={handleAddPayment}>
            <i className="ri-check-line me-1"></i>Add Payment
          </button>
        </div>
      </div>
    </div>
  </div>
)}



{showActionModal && (
  <div className="modal fade show d-block" tabIndex="-1"
       style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
    <div className="modal-dialog modal-dialog-centered modal-lg">
      <div className="modal-content">
        <div className="modal-header bg-primary text-white">
          <h5 className="modal-title">
            <i className="ri-checkbox-circle-line me-2" />Registration Saved — Choose an Action
          </h5>
          <button type="button" className="btn-close btn-close-white"
                  onClick={() => setShowActionModal(false)} />
        </div>
        <div className="modal-body">
          <div className="d-flex flex-wrap gap-2">
          <button type="button" className="btn btn-dark"
  onClick={() => { setDocType('receipt'); setPrintType('header'); setShowPopup(true); }}>
  <i className="ri-file-list-3-line me-1" />Print Receipt
</button>

<button type="button" className="btn btn-info"
  disabled={parseFloat(formData.opd_due || 0) !== 0}
  onClick={() => { setDocType('prescription'); setPrintType('header'); setShowPopup(true); }}>
  <i className="ri-capsule-line me-1" />Print Prescription
  {customOpdFormat && <span className="badge bg-warning ms-1" style={{fontSize:9}}>Custom</span>}
</button>

<button type="button" className="btn btn-primary" onClick={openProcedureModal}>
  <i className="ri-syringe-line me-1" />Add Procedure
</button>

<button type="button" className="btn btn-success" onClick={openLabModal}>
  <i className="ri-flask-line me-1" />Add Lab
</button>

<button type="button" className="btn btn-warning text-dark"
  disabled={movingToIpd} onClick={handleMoveToIpd}>
  <i className="ri-hospital-line me-1" />{movingToIpd ? 'Moving...' : 'Move to IPD'}
</button>

<button type="button" className="btn btn-danger" onClick={openEmergencyModal}>
  <i className="ri-alarm-warning-line me-1" />Add Day Care / Emergency
</button>

<button type="button" className="btn btn-secondary"
  disabled={!formData.opd_uhid}
  onClick={() => printThermalBarcodeIframe(
    `${formData.opd_patient_title || ''} ${formData.opd_patient_name || ''}`.trim(),
    (formatAgeFromParts(formData.opd_guardien_years, formData.opd_guardien_months, formData.opd_guardien_days) || formData.opd_guardien_age || 'N/A'),
    formData.opd_uhid
  )}>
  <i className="ri-barcode-line me-1" />Print Barcode
</button>
</div>

          <hr />

          <button type="button" className="btn btn-outline-primary w-100" onClick={clearForm}>
            <i className="ri-user-add-line me-1" />Add New Patient
          </button>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowActionModal(false)}>Close</button>
        </div>
      </div>
    </div>
  </div>
)}


{/* Procedure — real modal component you already have */}
{showProcedureModal && procedurePatientData && (
  <ProcedureBillModal
    patientData={procedurePatientData}
    image={headerLogo}
    watermarkImage={watermarkLogo}
    footerImage={footerImage}
    onClose={() => { setShowProcedureModal(false); setProcedurePatientData(null); }}
  />
)}

{/* Lab — the real page component, rendered inside a modal */}
<PageInModal show={showLabModal} title="Lab Registration"
  onClose={() => { setShowLabModal(false); sessionStorage.removeItem('lab_prefill'); }}>
  <LabRegistrations />
</PageInModal>

{/* Emergency / Day Care — the real page component, rendered inside a modal */}
<PageInModal show={showEmergencyModal} title="Day Care / Emergency Registration"
  onClose={() => { setShowEmergencyModal(false); sessionStorage.removeItem('emergency_dt'); }}>
  <EmergencyReg />
</PageInModal>

<NewBroker
  item={null}
  show={showBrokerModal}
  onClose={(refresh) => {
    setShowBrokerModal(false);
    if (refresh) {
      loadBrokers();
    }
  }}
/>
      </div>
    );
}
function PageInModal({ show, title, onClose, children }) {
  if (!show) return null;
  return (
    <div className="modal fade show d-block" tabIndex="-1"
         style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10050 }}>
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content" style={{ maxHeight: '92vh' }}>
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body" style={{ overflowY: 'auto' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
export default OpdRegistrations;
